{
  "starters": {
    "rewards": [
      {
        "key": "homework",
        "name": "Nộp bài đúng hạn",
        "emoji": "✓"
      },
      {
        "key": "help",
        "name": "Giúp đỡ bạn bè",
        "emoji": "🤝"
      },
      {
        "key": "cooperate",
        "name": "Hợp tác nhóm tốt",
        "emoji": "🌿"
      },
      {
        "key": "focus",
        "name": "Chú ý nghe giảng",
        "emoji": "👀"
      },
      {
        "key": "raise-hand",
        "name": "Hăng hái phát biểu",
        "emoji": "✋"
      },
      {
        "key": "challenge",
        "name": "Vượt thử thách",
        "emoji": "⭐"
      }
    ],
    "reminders": [
      {
        "key": "chatting",
        "name": "Nói chuyện riêng",
        "emoji": "💬"
      },
      {
        "key": "materials",
        "name": "Quên đồ dùng",
        "emoji": "🎒"
      },
      {
        "key": "late-homework",
        "name": "Nộp bài muộn",
        "emoji": "📋"
      },
      {
        "key": "disturbing",
        "name": "Mất tập trung",
        "emoji": "🔔"
      }
    ],
    "homework": [
      {
        "key": "language-workbook",
        "name": "Tập đọc",
        "emoji": "📖"
      },
      {
        "key": "language-writing",
        "name": "Chính tả",
        "emoji": "✏️"
      },
      {
        "key": "math-workbook",
        "name": "Bài tập Toán",
        "emoji": "🧮"
      },
      {
        "key": "contact-book",
        "name": "Sổ liên lạc",
        "emoji": "📝"
      }
    ],
    "daily": [
      {
        "key": "morning-reading",
        "name": "Bài đầu giờ",
        "emoji": "☀️"
      },
      {
        "key": "reading",
        "name": "Đọc 20 phút",
        "emoji": "📚"
      },
      {
        "key": "water",
        "name": "Bình nước",
        "emoji": "💧"
      },
      {
        "key": "cleaning",
        "name": "Gọn bàn học",
        "emoji": "🧹"
      },
      {
        "key": "materials",
        "name": "Cất cặp sách",
        "emoji": "🎒"
      }
    ],
    "store": [
      {
        "key": "sticker",
        "name": "Hình dán khen thưởng",
        "emoji": "🌈",
        "points": 5
      },
      {
        "key": "library-first",
        "name": "Chọn sách trước",
        "emoji": "📚",
        "points": 8
      },
      {
        "key": "helper",
        "name": "Trợ lý của cô",
        "emoji": "🤝",
        "points": 10
      },
      {
        "key": "seat",
        "name": "Tự chọn chỗ ngồi",
        "emoji": "🪑",
        "points": 15
      },
      {
        "key": "social-treat",
        "name": "Ăn trưa cùng cô",
        "emoji": "🍱",
        "points": 15
      },
      {
        "key": "homework-pass",
        "name": "Phiếu miễn bài tập",
        "emoji": "📝",
        "points": 20
      },
      {
        "key": "mystery",
        "name": "Quà tặng bí mật",
        "emoji": "🎁",
        "points": 25
      },
      {
        "key": "top-prize",
        "name": "Ngồi ghế giáo viên",
        "emoji": "👑",
        "points": 30
      }
    ],
    "instructions": [
      {
        "key": "ready",
        "title": "Chuẩn bị vào học",
        "steps": [
          "Lấy sách vở và bút ra bàn",
          "Mở đúng trang ghi trên bảng",
          "Hướng mắt lên bảng chú ý"
        ]
      },
      {
        "key": "group",
        "title": "Thảo luận nhóm",
        "steps": [
          "Lần lượt chia sẻ ý kiến của mình",
          "Ghi lại câu trả lời của nhóm",
          "Cử một bạn đại diện trình bày"
        ]
      },
      {
        "key": "finished",
        "title": "Làm xong sớm?",
        "steps": [
          "Kiểm tra xem đã ghi tên chưa",
          "Mang bài lên nộp",
          "Đọc sách giữ trật tự tại chỗ"
        ]
      },
      {
        "key": "pack-up",
        "title": "Thu dọn ra về",
        "steps": [
          "Cất gọn sách vở và đồ dùng",
          "Đẩy ghế vào gầm bàn và nhặt rác",
          "Xếp hàng ngay ngắn và giữ trật tự"
        ]
      }
    ],
    "phrases": [
      "Nhờ phụ huynh ký tên",
      "Sửa bài nộp vào ngày mai",
      "Nộp lại phiếu thông tin",
      "Nhớ mang theo bình nước",
      "Nhớ mang theo áo khoác",
      "Đi giày thể thao học thể dục",
      "Ngày mai kiểm tra chính tả",
      "Đến hạn trả sách thư viện"
    ],
    "duties": [
      "Xếp hàng",
      "Lau bảng",
      "Phát vở",
      "Phân rác",
      "Tắt điện",
      "Giữ cửa"
    ]
  },
  "certificate": {
    "awards": [
      {
        "id": "star",
        "label": "Học sinh tiêu biểu",
        "title": "Học Sinh Tiêu Biểu",
        "phrases": [
          "Vì luôn tỏa sáng mỗi ngày với sự chăm chỉ, lòng tốt và thái độ học tập tích cực.",
          "Vì đã trở thành tấm gương sáng tuyệt vời cho cả lớp noi theo.",
          "Vì đã luôn nỗ lực hết mình và mang lại nguồn năng lượng tích cực cho lớp học."
        ],
        "suffix": ""
      },
      {
        "id": "improved",
        "label": "Tiến bộ vượt bậc",
        "title": "Tiến Bộ Vượt Bậc",
        "phrases": [
          "Vì đã chăm chỉ rèn luyện suốt năm học và đạt được những tiến bộ đáng khen ngợi.",
          "Vì tinh thần không bỏ cuộc ngay cả khi gặp bài khó. Hãy nhìn xem em đã tiến bộ biết bao!"
        ],
        "suffix": ""
      },
      {
        "id": "reading",
        "label": "Vua đọc sách",
        "title": "Vua Đọc Sách",
        "phrases": [
          "Vì đã đọc rất nhiều cuốn sách hay và lan tỏa niềm yêu thích đọc sách đến mọi người.",
          "Vì luôn làm bạn với những trang sách và có thật nhiều câu chuyện thú vị để sẻ chia."
        ],
        "suffix": ""
      },
      {
        "id": "attendance",
        "label": "Chuyên cần xuất sắc",
        "title": "Chuyên Cần Xuất Sắc",
        "phrases": [
          "Vì đã đi học đầy đủ và đúng giờ mỗi ngày.",
          "Vì luôn đến lớp với tinh thần sẵn sàng học tập trong suốt học kỳ."
        ],
        "suffix": ""
      },
      {
        "id": "kindness",
        "label": "Tấm lòng nhân ái",
        "title": "Tấm Lòng Nhân Ái",
        "phrases": [
          "Vì luôn tốt bụng, biết quan tâm và sẵn lòng giúp đỡ bạn bè.",
          "Vì đã giúp mọi bạn trong lớp luôn cảm thấy được chào đón và gắn kết."
        ],
        "suffix": ""
      },
      {
        "id": "math",
        "label": "Tài năng Toán học",
        "title": "Tài Năng Toán Học",
        "phrases": [
          "Vì tư duy nhạy bén và niềm yêu thích đặc biệt khi giải các bài toán.",
          "Vì sự chăm chỉ trong môn Toán và tinh thần không ngại thử thách khó."
        ],
        "suffix": ""
      },
      {
        "id": "helper",
        "label": "Người bạn nhiệt tình",
        "title": "Người Bạn Nhiệt Tình",
        "phrases": [
          "Vì luôn sẵn sàng xung phong giúp đỡ thầy cô và các bạn trong lớp.",
          "Vì là một người bạn đáng tin cậy và luôn nhiệt tình giúp đỡ mọi người."
        ],
        "suffix": ""
      },
      {
        "id": "speller",
        "label": "Kiện tướng chính tả",
        "title": "Kiện Tướng Chính Tả",
        "phrases": [
          "Vì đã chăm chỉ rèn chữ và viết đúng những từ khó.",
          "Vì sự cẩn thận và viết đúng chính tả trong mọi bài viết."
        ],
        "suffix": ""
      },
      {
        "id": "creative",
        "label": "Tư duy sáng tạo",
        "title": "Tư Duy Sáng Tạo",
        "phrases": [
          "Vì những ý tưởng độc đáo, trí tưởng tượng phong phú và cách suy nghĩ mới mẻ.",
          "Đã tìm ra những cách sáng tạo để giải quyết vấn đề và chia sẻ ý tưởng."
        ],
        "suffix": ""
      },
      {
        "id": "leadership",
        "label": "Khả năng lãnh đạo",
        "title": "Giải Lãnh Đạo Xuất Sắc",
        "phrases": [
          "Đã luôn gương mẫu dẫn dắt và khơi dậy những điều tốt đẹp nhất ở mọi người.",
          "Đã là một người dẫn dắt có trách nhiệm và tôn trọng mọi người trong lớp."
        ],
        "suffix": ""
      },
      {
        "id": "citizen",
        "label": "Công dân tốt",
        "title": "Công Dân Gương Mẫu",
        "phrases": [
          "Đã luôn lễ phép, có trách nhiệm và công bằng với tất cả mọi người.",
          "Đã góp phần xây dựng lớp học và trường học thành một nơi tốt đẹp hơn cho tất cả mọi người."
        ],
        "suffix": ""
      },
      {
        "id": "worker",
        "label": "Chăm chỉ",
        "title": "Tấm Gương Chăm Chỉ",
        "phrases": [
          "Đã luôn nỗ lực hết mình mỗi ngày.",
          "Đã luôn tập trung và chăm chỉ hoàn thành mọi nhiệm vụ."
        ],
        "suffix": ""
      },
      {
        "id": "science",
        "label": "Ngôi sao khoa học",
        "title": "Ngôi Sao Khoa Học",
        "phrases": [
          "Đã đặt nhiều câu hỏi thú vị, quan sát tỉ mỉ và thực hiện các thí nghiệm tuyệt vời.",
          "Vì niềm yêu thích khám phá thế giới xung quanh của em."
        ],
        "suffix": ""
      },
      {
        "id": "writing",
        "label": "Giải viết văn",
        "title": "Cây Bút Triển Vọng",
        "phrases": [
          "Đã sáng tác những câu chuyện sáng tạo và có những bài viết sâu sắc, trau chuốt.",
          "Đã nỗ lực rèn luyện để bài viết luôn rõ ràng, sạch đẹp và cuốn hút."
        ],
        "suffix": ""
      },
      {
        "id": "sportsmanship",
        "label": "Tinh thần thể thao",
        "title": "Giải Tinh Thần Thể Thao",
        "phrases": [
          "Đã thi đấu công bằng, nhiệt tình cổ vũ bạn bè và là một đồng đội tuyệt vời.",
          "Đã biết khiêm tốn khi chiến thắng, mỉm cười khi thua cuộc và luôn cố gắng hết sức mình."
        ],
        "suffix": ""
      },
      {
        "id": "artist",
        "label": "Giải mỹ thuật",
        "title": "Họa Sĩ Nhí Tài Năng",
        "phrases": [
          "Đã sáng tạo những tác phẩm đầy màu sắc, giàu trí tưởng tượng và mang lại niềm vui cho mọi người.",
          "Vì sự sáng tạo và tỉ mỉ trong từng sản phẩm em làm ra."
        ],
        "suffix": ""
      },
      {
        "id": "attitude",
        "label": "Thái độ tích cực",
        "title": "Thái Độ Tích Cực",
        "phrases": [
          "Đã luôn nở nụ cười tươi tắn và giữ tinh thần sẵn sàng vượt khó mỗi ngày.",
          "Đã luôn giữ tinh thần lạc quan và lan tỏa năng lượng tích cực đến mọi người."
        ],
        "suffix": ""
      },
      {
        "id": "listener",
        "label": "Biết lắng nghe",
        "title": "Người Lắng Nghe Tuyệt Vời",
        "phrases": [
          "Đã luôn chú ý lắng nghe và làm theo hướng dẫn mỗi ngày.",
          "Đã luôn kiên nhẫn và tôn trọng khi lắng nghe người khác."
        ],
        "suffix": ""
      },
      {
        "id": "teamwork",
        "label": "Hợp tác tốt",
        "title": "Tinh Thần Đồng Đội",
        "phrases": [
          "Đã phối hợp ăn ý với bạn bè và giúp nhóm hoàn thành tốt nhiệm vụ.",
          "Đã tích cực chia sẻ ý tưởng, biết nhường nhịn và lắng nghe các bạn trong nhóm."
        ],
        "suffix": ""
      },
      {
        "id": "eco",
        "label": "Chiến binh xanh",
        "title": "Chiến Binh Xanh",
        "phrases": [
          "Đã chung tay bảo vệ hành tinh qua việc tái chế, tiết kiệm năng lượng và giữ trường lớp xanh sạch.",
          "Đã tích cực giữ gìn lớp học và trường học luôn xanh – sạch – đẹp."
        ],
        "suffix": ""
      }
    ],
    "thanks": [
      {
        "id": "volunteer",
        "label": "Tình nguyện viên lớp học",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn bạn đã dành thời gian quý báu để hỗ trợ lớp học. Tập thể lớp không thể thành công nếu thiếu sự đồng hành của bạn!",
          "Cảm ơn thời gian, tâm huyết và sự nhiệt tình bạn đã dành cho lớp trong suốt năm học qua."
        ],
        "suffix": ""
      },
      {
        "id": "parent",
        "label": "Phụ huynh hỗ trợ lớp",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn mọi sự giúp đỡ trong lớp học và sự quan tâm bạn dành cho từng học sinh.",
          "Cảm ơn bạn đã đồng hành cùng chúng tôi trong năm học này để giúp các em học sinh ngày càng trưởng thành."
        ],
        "suffix": ""
      },
      {
        "id": "room-parent",
        "label": "Ban đại diện cha mẹ học sinh",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn bạn đã đứng ra tổ chức các buổi liên hoan, sự kiện và hỗ trợ lớp rất nhiều trong năm học qua.",
          "Cảm ơn bạn đã gắn kết các gia đình trong lớp và giúp mọi buổi lễ, hoạt động diễn ra thật suôn sẻ."
        ],
        "suffix": ""
      },
      {
        "id": "speaker",
        "label": "Khách mời chia sẻ",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn bạn đã đến thăm lớp và chia sẻ những kiến thức, kinh nghiệm quý báu với chúng tôi.",
          "Cảm ơn buổi giao lưu đầy cảm hứng đã khơi dậy sự tò mò và ham học hỏi ở tất cả các em."
        ],
        "suffix": ""
      },
      {
        "id": "aide",
        "label": "Trợ giảng",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn sự kiên nhẫn, tận tâm và nỗ lực làm việc không ngừng nghỉ của bạn cùng các em học sinh mỗi ngày.",
          "Cảm ơn tất cả những hỗ trợ thiết thực bạn đã dành cho việc học tập và sinh hoạt của lớp."
        ],
        "suffix": ""
      },
      {
        "id": "chaperone",
        "label": "Người đồng hành dã ngoại",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn bạn đã giúp đảm bảo an toàn và mang lại niềm vui cho cả lớp trong chuyến dã ngoại.",
          "Cảm ơn bạn đã tham gia hành trình cùng lớp và góp phần tạo nên một ngày thật đáng nhớ."
        ],
        "suffix": ""
      },
      {
        "id": "donation",
        "label": "Nhà tài trợ hảo tâm",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn món quà quyên góp hào phóng gồm sách và đồ dùng học tập bạn đã dành tặng cho lớp.",
          "Cảm ơn tấm lòng vàng của bạn đã hỗ trợ lớp học và mang đến cho các em thêm nhiều cơ hội khám phá."
        ],
        "suffix": ""
      },
      {
        "id": "student-teacher",
        "label": "Giáo sinh thực tập",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Cảm ơn bạn đã mang nguồn năng lượng mới, sự sáng tạo và lòng tận tâm đến với lớp học.",
          "Cảm ơn sự chăm chỉ và cống hiến của bạn. Các em học sinh rất yêu thích những giờ học cùng bạn!"
        ],
        "suffix": ""
      },
      {
        "id": "class-helper",
        "label": "Cán sự lớp",
        "title": "Lời Cảm Ơn",
        "phrases": [
          "Đã luôn tự giác giúp đỡ thầy cô và bạn bè mỗi ngày mà không cần nhắc nhở.",
          "Đã là người hỗ trợ đáng tin cậy, giúp các hoạt động của lớp diễn ra suôn sẻ."
        ],
        "suffix": ""
      }
    ],
    "closings": {
      "award": "Hãy tiếp tục phát huy nhé!",
      "thanks": "Xin chân thành cảm ơn."
    },
    "labels": {
      "award": "Giấy khen Thành tích",
      "thanks": "Giấy Chứng Nhận Tri Ân"
    },
    "awardTitle": "Giấy khen Thành tích",
    "suffixes": [],
    "signers": [
      "Giáo viên",
      "Hiệu trưởng",
      ""
    ],
    "dateStyles": [
      "ad",
      "blank"
    ],
    "papers": [
      "a4",
      "letter"
    ],
    "limits": {
      "title": 30,
      "phrase": 120,
      "field": 40
    },
    "defaults": {
      "kind": "award",
      "preset": {
        "award": "star",
        "thanks": "volunteer"
      },
      "customTitle": "",
      "phrase": 0,
      "customPhrase": "",
      "suffix": null,
      "template": "forest",
      "nameStyle": "blank",
      "school": "",
      "className": "",
      "signer": "Giáo viên",
      "teacher": "",
      "dateStyle": "ad",
      "date": "",
      "closing": true,
      "paper": "a4"
    }
  },
  "charades": [
    {
      "id": "animals",
      "name": "Động vật",
      "easy": [
        "con mèo",
        "con chó",
        "con thỏ",
        "con khỉ",
        "con voi",
        "hươu cao cổ",
        "sư tử",
        "con hổ",
        "chim cánh cụt",
        "chuột túi",
        "con ếch",
        "con rắn",
        "cá sấu",
        "con rùa",
        "con cua",
        "con chim",
        "con gà",
        "con vịt",
        "con lợn",
        "con bò",
        "con ngựa",
        "con cừu",
        "con gấu",
        "bươm bướm",
        "con ong",
        "cá vàng",
        "bạch tuộc",
        "cá voi",
        "con chuột",
        "chim cú mèo",
        "ốc sên",
        "con nhện",
        "khủng long",
        "ngựa vằn"
      ],
      "hard": [
        "chim công",
        "lạc đà",
        "tê giác",
        "chim gõ kiến",
        "tắc kè hoa",
        "cá heo",
        "cá mập",
        "con kiến",
        "con muỗi",
        "con dơi",
        "hải cẩu",
        "con sứa",
        "chim hồng hạc",
        "con nhím",
        "con lười",
        "con sóc",
        "khỉ đột",
        "đại bàng",
        "sâu bướm"
      ]
    },
    {
      "id": "jobs",
      "name": "Nghề nghiệp",
      "easy": [
        "giáo viên",
        "bác sĩ",
        "y tá",
        "cảnh sát",
        "lính cứu hỏa",
        "đầu bếp",
        "nông dân",
        "người đưa thư",
        "thợ cắt tóc",
        "họa sĩ",
        "ca sĩ",
        "ảo thuật gia",
        "phi hành gia",
        "phi công",
        "nha sĩ",
        "bác sĩ thú y",
        "tài xế xe buýt",
        "nhân viên cứu hộ",
        "thợ làm bánh",
        "nhiếp ảnh gia",
        "chú hề",
        "vũ công",
        "thợ sửa xe",
        "thu ngân",
        "thợ xây",
        "người chăm thú sở thú",
        "thủ thư",
        "người làm vườn",
        "người dẫn đường qua phố"
      ],
      "hard": [
        "phóng viên",
        "luật sư",
        "thẩm phán",
        "nhà khoa học",
        "nhà khảo cổ",
        "kỹ sư",
        "thợ mộc",
        "thợ may",
        "phát thanh viên thời sự",
        "hướng dẫn viên du lịch",
        "tiếp viên hàng không",
        "nhạc trưởng",
        "thợ sửa ống nước",
        "thuyền trưởng",
        "nhà phát minh",
        "nhà điêu khắc",
        "đạo diễn phim",
        "nhà văn",
        "người dự báo thời tiết",
        "thám tử",
        "bác sĩ phẫu thuật"
      ]
    },
    {
      "id": "sports",
      "name": "Thể thao & trò chơi",
      "easy": [
        "chạy bộ",
        "bơi lội",
        "nhảy dây",
        "bóng rổ",
        "bóng đá",
        "bóng chày",
        "bóng chuyền",
        "bóng bàn",
        "cầu lông",
        "trượt ván",
        "đạp xe",
        "trượt băng",
        "kéo co",
        "nhảy cao",
        "nhảy xa",
        "đi bộ đường dài",
        "thể dục dụng cụ",
        "lắc vòng",
        "bóng gỗ bowling",
        "quần vợt",
        "nhảy cầu",
        "lướt sóng",
        "trượt tuyết ván đôi",
        "bóng né",
        "chống đẩy",
        "nhảy lò cò",
        "trò đuổi bắt",
        "trốn tìm",
        "võ karate",
        "trò chơi giành ghế"
      ],
      "hard": [
        "cử tạ",
        "đấu kiếm",
        "đánh gôn",
        "chèo thuyền",
        "nhảy sào",
        "đẩy tạ",
        "ném lao",
        "chạy vượt rào",
        "đấu vật sumo",
        "võ judo",
        "leo núi đá",
        "trượt băng nghệ thuật",
        "chạy marathon",
        "dù lượn",
        "chèo thuyền kayak",
        "gập bụng",
        "tập yoga",
        "trượt tuyết ván đơn",
        "bắn cung",
        "chạy tiếp sức"
      ]
    },
    {
      "id": "food",
      "name": "Đồ ăn",
      "easy": [
        "quả táo",
        "quả chuối",
        "dưa hấu",
        "chùm nho",
        "quả dứa",
        "dâu tây",
        "kem lạnh",
        "bánh kem",
        "bánh mì kẹp thịt bò",
        "khoai tây chiên",
        "bánh pizza",
        "bánh mì",
        "bánh mì sandwich",
        "mì Ý",
        "trứng ốp la",
        "bắp ngô",
        "kẹo mút",
        "bỏng ngô",
        "bánh mì kẹp xúc xích",
        "bánh quy",
        "sữa tươi",
        "kẹo bông gòn",
        "sô-cô-la",
        "quả cam",
        "củ cà rốt",
        "phô mai",
        "bánh kếp",
        "ngũ cốc ăn sáng",
        "bánh taco",
        "món súp"
      ],
      "hard": [
        "cơm cuộn sushi",
        "bông cải xanh",
        "bánh quy xoắn",
        "bánh cuộn burrito",
        "nước chanh",
        "bơ đậu phộng",
        "bánh nướng nhỏ",
        "bánh tổ ong",
        "sinh tố",
        "rau trộn",
        "mì sợi",
        "há cảo",
        "quả dừa",
        "quả bơ",
        "dưa chuột muối",
        "quả xoài",
        "kẹo dẻo",
        "kẹo cao su thổi bóng",
        "quả ớt",
        "thịt viên"
      ]
    },
    {
      "id": "actions",
      "name": "Hành động",
      "easy": [
        "đánh răng",
        "rửa mặt",
        "tắm rửa",
        "đi ngủ",
        "ăn cơm",
        "uống nước",
        "mặc quần áo",
        "buộc dây giày",
        "chải tóc",
        "ngáp ngủ",
        "hắt xì",
        "vỗ tay",
        "vẫy tay",
        "bật nhảy",
        "bò dưới đất",
        "leo cầu thang",
        "nhảy múa",
        "ca hát",
        "cười lớn",
        "khóc nhè",
        "thổi bong bóng xà phòng",
        "thả diều",
        "tưới cây",
        "dắt chó đi dạo",
        "đọc sách",
        "chụp ảnh",
        "mở cửa",
        "quét nhà",
        "rửa bát",
        "ôm nhau"
      ],
      "hard": [
        "đi tất",
        "xì mũi",
        "cắt móng tay",
        "ủi quần áo",
        "lật bánh trên chảo",
        "sấy tóc",
        "gấp quần áo",
        "thắt cà vạt",
        "đi thang máy",
        "băng qua đường",
        "bê thùng nặng",
        "tìm chìa khóa",
        "bị muỗi đốt",
        "dẫm phải bã kẹo cao su",
        "chụp ảnh tự sướng",
        "vươn vai",
        "tung hứng",
        "đi nhón chân",
        "run lập cập",
        "đan len",
        "sơn tường"
      ]
    },
    {
      "id": "school",
      "name": "Ở trường học",
      "easy": [
        "bút chì",
        "cục tẩy",
        "cặp sách",
        "cái kéo",
        "hồ dán",
        "bút sáp màu",
        "thước kẻ",
        "bàn học",
        "bảng trắng",
        "quyển vở",
        "hộp cơm trưa",
        "bình nước",
        "giờ ra chơi",
        "giơ tay phát biểu",
        "xếp hàng",
        "bài tập về nhà",
        "bài kiểm tra chính tả",
        "giờ ăn trưa",
        "cầu trượt",
        "xích đu",
        "bập bênh",
        "gọt bút chì",
        "sân chơi",
        "mang đồ đến lớp giới thiệu",
        "giờ kể chuyện",
        "cọ vẽ",
        "hộp bút",
        "xe đưa đón học sinh",
        "khung leo trèo"
      ],
      "hard": [
        "kính hiển vi",
        "quả địa cầu",
        "máy tính bỏ túi",
        "thí nghiệm khoa học",
        "từ điển",
        "bảng cửu chương",
        "diễn tập phòng cháy",
        "chuyến dã ngoại của trường",
        "vở kịch ở trường",
        "lễ tốt nghiệp",
        "ảnh chụp tập thể lớp",
        "ngày hội thể thao",
        "thẻ thư viện",
        "bảng tin",
        "đồ bấm kim",
        "bút dạ quang",
        "thẻ xin phép ra ngoài lớp",
        "cuộc thi đánh vần",
        "hội chợ sách"
      ]
    },
    {
      "id": "home",
      "name": "Đồ vật trong nhà",
      "easy": [
        "cái giường",
        "cái gối",
        "cái chăn",
        "ghế sô-pha",
        "cái bàn",
        "cái ghế",
        "đèn bàn",
        "cửa sổ",
        "bồn tắm",
        "bàn chải đánh răng",
        "khăn tắm",
        "cục xà phòng",
        "cái gương",
        "ti-vi",
        "tủ lạnh",
        "lò nướng",
        "đồng hồ treo tường",
        "điện thoại",
        "cái cốc",
        "cái thìa",
        "cái nĩa",
        "cái đĩa",
        "gấu bông",
        "cái chổi",
        "thùng rác",
        "máy giặt",
        "cái ô",
        "vịt cao su",
        "bồn rửa",
        "chìa khóa"
      ],
      "hard": [
        "máy hút bụi",
        "lò vi sóng",
        "máy nướng bánh mì",
        "chuông cửa",
        "quạt trần",
        "kệ sách",
        "giỏ đựng đồ giặt",
        "máy rửa bát",
        "đồng hồ báo thức",
        "máy sấy tóc",
        "máy xay sinh tố",
        "điều khiển từ xa",
        "giường tầng",
        "đèn pin",
        "móc treo quần áo",
        "hộp thư",
        "công tắc đèn",
        "máy báo khói"
      ]
    },
    {
      "id": "places",
      "name": "Địa điểm",
      "easy": [
        "công viên",
        "bãi biển",
        "sở thú",
        "nông trại",
        "thư viện",
        "bệnh viện",
        "siêu thị",
        "sân bay",
        "nhà ga",
        "tiệm bánh",
        "hồ bơi",
        "khu rừng",
        "ngọn núi",
        "dòng sông",
        "lâu đài",
        "viện bảo tàng",
        "nhà hàng",
        "trạm cứu hỏa",
        "cửa hàng thú cưng",
        "cửa hàng đồ chơi",
        "trạm xe buýt",
        "khu vườn",
        "sa mạc",
        "hòn đảo",
        "rừng rậm",
        "hang động",
        "rạp xiếc",
        "rạp chiếu phim"
      ],
      "hard": [
        "thủy cung",
        "ngân hàng",
        "bưu điện",
        "tiệm làm tóc",
        "phòng khám nha khoa",
        "sân chơi bowling",
        "công viên giải trí",
        "núi lửa",
        "ngọn hải đăng",
        "tòa nhà chọc trời",
        "khu cắm trại",
        "thác nước",
        "công trường xây dựng",
        "tiệm giặt là",
        "trạm xăng",
        "chợ nông sản",
        "trạm vũ trụ",
        "nhà ma",
        "lều tuyết"
      ]
    },
    {
      "id": "feelings",
      "name": "Cảm xúc",
      "easy": [
        "vui vẻ",
        "buồn bã",
        "tức giận",
        "sợ hãi",
        "ngạc nhiên",
        "mệt mỏi",
        "buồn ngủ",
        "đói bụng",
        "khát nước",
        "hào hứng",
        "chán nản",
        "nhút nhát",
        "ngớ ngẩn",
        "tự hào",
        "lạnh giá",
        "nóng nực",
        "bị ốm",
        "cáu kỉnh",
        "lo lắng",
        "dũng cảm",
        "bình tĩnh",
        "cô đơn",
        "ấm áp dễ chịu",
        "chóng mặt",
        "bối rối",
        "nhột"
      ],
      "hard": [
        "hồi hộp",
        "xấu hổ",
        "bực bội",
        "ghen tị",
        "thất vọng",
        "tò mò",
        "nhẹ nhõm",
        "biết ơn",
        "thiếu kiên nhẫn",
        "tự tin",
        "ghê tởm",
        "sửng sốt",
        "hy vọng",
        "bướng bỉnh",
        "lén lút",
        "kiệt sức",
        "quyết tâm",
        "khó hiểu"
      ]
    },
    {
      "id": "seasons",
      "name": "Ngày lễ & các mùa",
      "easy": [
        "tiệc sinh nhật",
        "thổi nến",
        "mở quà",
        "pháo hoa",
        "người tuyết",
        "ném bóng tuyết",
        "trượt xe trên tuyết",
        "cào lá khô",
        "nhảy vào vũng nước",
        "cầu vồng",
        "kính râm",
        "lâu đài cát",
        "kem que",
        "dã ngoại",
        "gieo hạt",
        "quả bí ngô",
        "tiệc hóa trang",
        "diễu hành",
        "ca cao nóng",
        "găng tay",
        "khăn quàng cổ",
        "kem chống nắng",
        "bão sấm sét",
        "bóng hơi bãi biển",
        "chuyến đi cắm trại",
        "lá rụng"
      ],
      "hard": [
        "đếm ngược đón năm mới",
        "trò xin kẹo lễ hội hóa trang",
        "khắc bí ngô",
        "hái táo",
        "gói quà",
        "ước nguyện",
        "tổng vệ sinh mùa xuân",
        "kỳ nghỉ hè",
        "đợt nắng nóng",
        "bão tuyết",
        "mưa đá",
        "lễ hội mùa thu",
        "sum họp gia đình",
        "ngày nghỉ học vì tuyết",
        "nhà bánh gừng",
        "trò tìm trứng",
        "pháo bông cầm tay",
        "ngồi xe kéo chở rơm",
        "quầy bán nước chanh"
      ]
    }
  ],
  "grades": [
    {
      "label": "Mầm non",
      "options": [
        {
          "value": "k1",
          "label": "Mẫu giáo 3–4 tuổi"
        },
        {
          "value": "k2",
          "label": "Mẫu giáo 4–5 tuổi"
        },
        {
          "value": "k3",
          "label": "Mẫu giáo 5–6 tuổi"
        }
      ]
    },
    {
      "label": "Tiểu học",
      "options": [
        {
          "value": "g1",
          "label": "Lớp 1"
        },
        {
          "value": "g2",
          "label": "Lớp 2"
        },
        {
          "value": "g3",
          "label": "Lớp 3"
        },
        {
          "value": "g4",
          "label": "Lớp 4"
        },
        {
          "value": "g5",
          "label": "Lớp 5"
        }
      ]
    },
    {
      "label": "Trung học cơ sở",
      "options": [
        {
          "value": "g6",
          "label": "Lớp 6"
        },
        {
          "value": "g7",
          "label": "Lớp 7"
        },
        {
          "value": "g8",
          "label": "Lớp 8"
        },
        {
          "value": "g9",
          "label": "Lớp 9"
        }
      ]
    },
    {
      "label": "Trung học phổ thông",
      "options": [
        {
          "value": "g10",
          "label": "Lớp 10"
        },
        {
          "value": "g11",
          "label": "Lớp 11"
        },
        {
          "value": "g12",
          "label": "Lớp 12"
        }
      ]
    },
    {
      "label": "Khác",
      "options": [
        {
          "value": "mixed",
          "label": "Lớp ghép / Ngoại khóa"
        },
        {
          "value": "adult",
          "label": "Đại học / Người lớn"
        },
        {
          "value": "other",
          "label": "Khác / Không áp dụng"
        }
      ]
    }
  ],
  "comments": {
    "traits": {
      "focus": {
        "kw": "sự chú ý lắng nghe trong lớp",
        "lines": [
          "{N} chăm chú lắng nghe trong lớp và theo dõi sát từng bài học.",
          "{○○ là|Em là} một học sinh tập trung, luôn chú tâm vào bài học trong giờ.",
          "Trong giờ học, {N} luôn hướng mắt về phía người nói và nắm bắt hướng dẫn ngay từ lần đầu.",
          "Khả năng tập trung của {N} giúp {○○|em} tiếp thu kiến thức mới nhanh chóng.",
          "Ngay cả khi lớp học ồn ào, {N} vẫn giữ được sự tập trung vào nhiệm vụ đang làm.",
          "{○○ lắng nghe|Em lắng nghe} kỹ hướng dẫn và bắt tay vào làm bài ngay lập tức."
        ]
      },
      "effort": {
        "kw": "tinh thần học tập nghiêm túc",
        "lines": [
          "{N} nỗ lực thực sự trong mọi nhiệm vụ và tự hào khi hoàn thành tốt công việc.",
          "{○○ đã|Em đã} thể hiện tinh thần học tập nghiêm túc trong suốt học kỳ.",
          "{N} luôn dốc hết sức cho mọi bài tập, dù dễ hay khó.",
          "Sự chăm chỉ là một trong những điểm mạnh lớn nhất của {N}.",
          "{○○ luôn|Em luôn} sẵn sàng dành thời gian cần thiết để hoàn thành tốt bài vở.",
          "Rõ ràng là {○○ rất|em rất} coi trọng việc học và luôn cố gắng hết sức mình."
        ]
      },
      "homework": {
        "kw": "bài tập về nhà gọn gàng, đầy đủ",
        "lines": [
          "{N} luôn nộp bài tập về nhà đầy đủ, sạch đẹp và đúng hạn.",
          "Bài làm của {N} thể hiện sự cẩn thận và chú ý đến từng chi tiết.",
          "Bài tập về nhà được nộp đúng hạn và thể hiện sự chăm chút thực sự.",
          "{N} hoàn thành bài tập kỹ lưỡng và trình bày rất gọn gàng.",
          "{○○ làm|Em làm} bài tập về nhà rất nghiêm túc, điều đó thể hiện rõ qua chất lượng bài làm.",
          "Bài tập về nhà của {N} luôn gọn gàng, đầy đủ và được đầu tư suy nghĩ kỹ càng."
        ]
      },
      "speak": {
        "kw": "sự tự tin phát biểu xây dựng bài",
        "lines": [
          "{N} tích cực tham gia thảo luận và tự tin chia sẻ ý kiến.",
          "{○○ luôn|Em luôn} sẵn sàng giơ tay phát biểu và đóng góp vào các buổi thảo luận của lớp.",
          "{N} nhanh nhẹn chia sẻ ý tưởng và đóng góp rất nhiều cho các cuộc trao đổi trên lớp.",
          "Các buổi thảo luận trên lớp trở nên sôi nổi và sâu sắc hơn nhờ những đóng góp thấu đáo của {N}.",
          "{○○ tự tin|Em tự tin} phát biểu và biết phát triển thêm dựa trên ý tưởng của các bạn khác.",
          "Khi có câu hỏi được đặt ra, {N} thường là một trong những người đầu tiên xung phong trả lời."
        ]
      },
      "curious": {
        "kw": "tính ham học hỏi tự nhiên",
        "lines": [
          "{N} mang sự tò mò tự nhiên vào việc học và thường đặt ra những câu hỏi sâu sắc.",
          "{○○ luôn|Em luôn} háo hức khám phá những ý tưởng mới và tìm hiểu cách mọi thứ vận hành.",
          "Sự ham học hỏi của {N} dẫn đến những câu hỏi rất hay, giúp cả lớp suy nghĩ sâu sắc hơn.",
          "{N} rất thích tìm hiểu nguyên nhân vì sao mọi việc xảy ra và cách chúng hoạt động.",
          "Những chủ đề mới luôn khơi dậy sự hứng thú của {N}, và {○○ luôn|em luôn} khao khát tìm hiểu thêm.",
          "{○○ đặt|Em đặt} ra những câu hỏi cho thấy sự suy ngẫm thực sự và mong muốn hiểu rõ vấn đề."
        ]
      },
      "reading": {
        "kw": "niềm yêu thích đọc sách",
        "lines": [
          "{N} có niềm yêu thích đọc sách thực sự và thường xuyên được bắt gặp với một cuốn sách trên tay.",
          "Thói quen đọc sách của {N} đã giúp xây dựng vốn từ vựng phong phú và kiến thức sâu rộng.",
          "{N} đọc rất nhiều thể loại và thích trò chuyện về những cuốn sách yêu thích.",
          "Giờ đọc sách rõ ràng là khoảng thời gian yêu thích nhất trong ngày của {N}.",
          "{○○ hào hứng|Em hào hứng} chọn sách và đọc ngày càng trôi chảy cũng như hiểu sâu nội dung hơn.",
          "Tình yêu sách thể hiện rõ qua vốn từ vựng và các bài viết của {N}."
        ]
      },
      "careful": {
        "kw": "bài làm cẩn thận, chính xác",
        "lines": [
          "{N} làm bài cẩn thận và luôn kiểm tra lại độ chính xác trước khi nộp.",
          "{○○ chú ý|Em chú ý} kỹ đến từng chi tiết trong mọi nhiệm vụ.",
          "{N} dành thời gian để làm đúng từng chi tiết và hiếm khi làm bài qua loa vội vàng.",
          "Bài làm của {N} chính xác, kỹ lưỡng và được trình bày gọn gàng.",
          "{○○ kiểm tra|Em kiểm tra} câu trả lời cẩn thận và tự sửa những lỗi sai nhỏ trước khi nộp bài.",
          "Sự tỉ mỉ và chú ý đến chi tiết là một điểm mạnh thực sự trong bài làm hằng ngày của {N}."
        ]
      },
      "selfdriven": {
        "kw": "tính tự giác và chủ động",
        "lines": [
          "{N} chủ động trong học tập và hoàn thành nhiệm vụ mà không cần nhắc nhở.",
          "{○○|Em} là học sinh có tinh thần tự giác, luôn tìm cách tiến bộ.",
          "{N} bắt tay vào công việc ngay và làm việc độc lập rất tốt.",
          "{○○|Em} tự đặt mục tiêu cá nhân và kiên trì nỗ lực để đạt được.",
          "Không cần nhắc nhở, {N} thường chủ động tìm cách học hỏi thêm.",
          "{○○|Em} có tinh thần tự giác học tập, rất ít khi cần nhắc nhở."
        ]
      },
      "persist": {
        "kw": "sự kiên trì",
        "lines": [
          "{N} thể hiện sự kiên trì tuyệt vời và luôn cố gắng khi gặp bài khó.",
          "{○○|Em} không dễ bỏ cuộc và nỗ lực hết mình để vượt qua khó khăn.",
          "{N} vẫn kiên trì khi bài vở khó khăn và hoàn thành nhiệm vụ đến cùng.",
          "Thử thách không làm {○○|em} nản lòng; thay vào đó, {○○|em} thử lại theo hướng tiếp cận mới.",
          "Sự quyết tâm của {N} thể hiện rõ mỗi khi nhiệm vụ đòi hỏi thêm nhiều nỗ lực.",
          "{○○|Em} hiểu rằng sai sót là một phần của việc học và vẫn tiếp tục cố gắng."
        ]
      },
      "kind": {
        "kw": "lòng nhân hậu",
        "lines": [
          "{N} thể hiện sự tử tế và đồng cảm với mọi người.",
          "{○○|Em} biết quan tâm và chu đáo, giúp các bạn trong lớp luôn cảm thấy thoải mái khi ở bên {○○|em}.",
          "{N} nhận ra khi người khác cần an ủi và đáp lại bằng sự ấm áp.",
          "Sự quan tâm của {N} giúp các bạn trong lớp cảm thấy được trân trọng và an tâm.",
          "Những hành động tử tế nhỏ bé là điều tự nhiên trong mỗi ngày của {N}.",
          "{○○|Em} đối xử nhẹ nhàng với mọi người và luôn nghĩ đến cảm xúc của người khác."
        ]
      },
      "honest": {
        "kw": "tính trung thực",
        "lines": [
          "{N} trung thực và dám nhận trách nhiệm khi mắc lỗi.",
          "{○○|Em} nhận được sự tin tưởng của thầy cô và bạn bè nhờ tính trung thực.",
          "{N} luôn nói thật ngay cả khi điều đó không dễ dàng.",
          "Tính trung thực của {N} khiến {○○|em} trở thành người mà mọi người có thể tin cậy.",
          "{○○|Em} dám nhận lỗi và rút kinh nghiệm từ những sai sót đó.",
          "Thầy cô và bạn bè đều biết rằng lời nói của {N} rất đáng tin cậy."
        ]
      },
      "polite": {
        "kw": "sự lễ phép, lịch sự",
        "lines": [
          "{N} lễ phép và tôn trọng thầy cô cũng như bạn bè.",
          "Sự lễ phép và lịch sự của {N} được mọi người ở trường ghi nhận.",
          "{N} biết nói lời cảm ơn, xin lỗi và thưa gửi lễ phép mà không cần nhắc nhở.",
          "Tác phong lịch sự của {N} tạo ấn tượng tốt đẹp với mọi người.",
          "{○○|Em} chào hỏi người lớn và bạn bè niềm nở, ăn nói lễ phép.",
          "Sự lễ phép đến rất tự nhiên với {○○|em}, cả trong lớp học lẫn trong khuôn viên trường."
        ]
      },
      "responsible": {
        "kw": "tinh thần trách nhiệm cao",
        "lines": [
          "{N} luôn đáng tin cậy trong việc hoàn thành nhiệm vụ đến nơi đến chốn.",
          "{○○|Em} có ý thức trách nhiệm nghiêm túc và là một thành viên đáng tin cậy của lớp.",
          "{N} thực hiện đúng cam kết và có thể được tin tưởng giao những công việc quan trọng.",
          "Sự đáng tin cậy của {N} là điều mà thầy cô và các bạn luôn yên tâm.",
          "Khi được giao nhiệm vụ, {N} đều thực hiện cẩn thận cho đến cùng.",
          "{○○|Em} có ý thức tự quản đối với nhiệm vụ được giao và đồ dùng cá nhân."
        ]
      },
      "positive": {
        "kw": "thái độ tích cực",
        "lines": [
          "{N} mang đến lớp thái độ vui vẻ, tích cực mỗi ngày.",
          "Sự lạc quan và vui tươi của {N} làm bừng sáng cả lớp học.",
          "{N} đón chào mỗi ngày mới bằng nụ cười và tinh thần lạc quan.",
          "Sự nhiệt tình của {N} lan tỏa và khuấy động không khí của cả lớp.",
          "Ngay cả khi gặp việc khó, {N} vẫn giữ được sự vui vẻ và lạc quan.",
          "{○○|Em} mang lại sự ấm áp và niềm vui cho lớp học của chúng ta."
        ]
      },
      "confident": {
        "kw": "sự tự tin",
        "lines": [
          "{N} đón nhận những thử thách mới một cách tự tin.",
          "{○○|Em} sẵn sàng thử những điều mới và không ngại mắc lỗi.",
          "{N} giải quyết những nhiệm vụ mới mẻ với tinh thần tự tin, quyết tâm.",
          "Sự tự tin của {N} thể hiện rõ khi chia sẻ bài làm hoặc thử sức với điều mới.",
          "{○○|Em} hào hứng đón nhận thử thách và không ngại những câu hỏi khó.",
          "{N} tiếp cận những tình huống mới một cách bình tĩnh và tự tin."
        ]
      },
      "helpful": {
        "kw": "tinh thần hay giúp đỡ",
        "lines": [
          "{N} luôn sẵn sàng giúp đỡ những bạn trong lớp đang cần hỗ trợ.",
          "{○○|Em} thường xuyên chủ động giúp đỡ và kiên nhẫn giảng giải cho các bạn.",
          "{N} nhận ra khi có bạn gặp lúng túng và lập tức hỗ trợ ngay.",
          "Sự nhiệt tình giúp đỡ của {N} mang lại ý nghĩa thiết thực cho các bạn trong lớp.",
          "Các bạn trong lớp thường tìm đến {○○|em} khi cần giúp đỡ và {○○|em} luôn sẵn lòng.",
          "{○○|Em} tự giác giúp đỡ mọi người với nụ cười luôn nở trên môi."
        ]
      },
      "teamwork": {
        "kw": "tinh thần hợp tác nhóm",
        "lines": [
          "{N} làm việc nhóm rất tốt, biết lắng nghe người khác và chia sẻ công việc.",
          "{○○|Em} là thành viên có tinh thần hợp tác, góp phần giúp cả nhóm thành công.",
          "{N} tích cực đóng góp ý kiến khi làm việc nhóm và trân trọng ý kiến của các bạn.",
          "Trong các dự án nhóm, {N} phân chia nhiệm vụ công bằng và khích lệ các thành viên.",
          "Tinh thần hợp tác của {N} giúp cả nhóm phối hợp nhịp nhàng với nhau.",
          "{○○|Em} biết cách dung hòa ý kiến để cả nhóm cùng đạt kết quả tốt."
        ]
      },
      "friendly": {
        "kw": "sự thân thiện",
        "lines": [
          "{N} hòa đồng với các bạn trong lớp và là người bạn tốt của nhiều người.",
          "{○○|Em} thân thiện và hòa đồng, giúp mọi người cảm thấy được chào đón.",
          "{N} dễ kết bạn và luôn rủ các bạn cùng tham gia trò chơi, hoạt động.",
          "Sự ấm áp, thân thiện của {N} giúp các bạn trong lớp cảm thấy gần gũi.",
          "{○○|Em} dễ gần, hòa đồng và tốt bụng với tất cả mọi người.",
          "Các bạn trong lớp rất thích ở bên {N}, cả trong giờ học lẫn giờ chơi."
        ]
      },
      "leader": {
        "kw": "khả năng lãnh đạo",
        "lines": [
          "{N} thể hiện kỹ năng lãnh đạo tốt và dẫn dắt hoạt động nhóm hiệu quả.",
          "{○○|Em} có tố chất dẫn dắt tự nhiên và được các bạn trong lớp quý mến, tin tưởng.",
          "{N} chủ động dẫn dắt công việc nhóm đồng thời vẫn biết lắng nghe các bạn.",
          "Các bạn trong lớp tôn trọng ý kiến của {N} và vui vẻ hưởng ứng.",
          "{○○|Em} tổ chức hoạt động nhóm tốt và đảm bảo bạn nào cũng có phần việc phù hợp.",
          "Phong cách dẫn dắt của {N} điềm tĩnh, công bằng và giàu tính khích lệ."
        ]
      },
      "respect": {
        "kw": "sự tôn trọng người khác",
        "lines": [
          "{N} lắng nghe người khác một cách tôn trọng và trân trọng những góc nhìn khác nhau.",
          "{○○|Em} đối xử tôn trọng với tất cả mọi người.",
          "{N} biết chờ đến lượt mới phát biểu và chăm chú lắng nghe các bạn.",
          "Thái độ tôn trọng của {N} góp phần xây dựng môi trường lớp học tích cực.",
          "{○○|Em} tôn trọng sự khác biệt và nói chuyện lịch sự với mọi người.",
          "Sự tôn trọng người khác thể hiện rõ qua cách {○○|em} lắng nghe và phản hồi."
        ]
      },
      "share": {
        "kw": "sự rộng lượng, sẻ chia",
        "lines": [
          "{N} sẵn lòng chia sẻ ý tưởng và đồ dùng học tập với các bạn.",
          "{○○|Em} thích chia sẻ những điều mình đã học được với mọi người.",
          "{N} vui vẻ chia sẻ đồ dùng và biết nhường nhịn, thay phiên nhau.",
          "Tinh thần sẻ chia của {N} được mọi người trong lớp quý mến.",
          "{○○|Em} sẵn sàng chia sẻ ý tưởng và tài liệu khi làm việc nhóm.",
          "Việc sẻ chia đến rất tự nhiên với {○○|em}, dù là đồ dùng, ý tưởng hay thời gian."
        ]
      },
      "tidy": {
        "kw": "tính ngăn nắp, khoa học",
        "lines": [
          "{○○|Em} giữ bàn học gọn gàng và sắp xếp đồ dùng học tập ngăn nắp.",
          "{○○|Em} có tính ngăn nắp và luôn chuẩn bị sẵn sàng cho các tiết học.",
          "Góc học tập của {N} luôn gọn gàng, dễ tìm thấy đồ dùng khi cần.",
          "{N} giữ gìn sách vở và đồ dùng học tập ngăn nắp, cẩn thận.",
          "Sau các hoạt động, {N} thu dọn nhanh chóng và giữ chỗ ngồi sạch sẽ.",
          "Tính ngăn nắp giúp {○○|em} bắt đầu mỗi tiết học với tâm thế sẵn sàng."
        ]
      },
      "punctual": {
        "kw": "tính đúng giờ",
        "lines": [
          "{N} đến lớp đúng giờ mỗi ngày với tâm thế sẵn sàng học tập.",
          "{○○|Em} quản lý thời gian tốt và hoàn thành công việc đúng hạn.",
          "{N} luôn đúng giờ và chuẩn bị sẵn sàng khi tiết học bắt đầu.",
          "Tính đúng giờ của {N} giúp {○○|em} tận dụng hiệu quả mỗi ngày đến trường.",
          "{○○|Em} nộp bài đúng hạn và biết sử dụng thời gian hợp lý.",
          "Đến lớp đúng giờ và chuẩn bị bài chu đáo là thói quen mà {○○|em} đã rèn luyện rất tốt."
        ]
      },
      "rules": {
        "kw": "tính tự giác kỷ luật",
        "lines": [
          "{N} thực hiện tốt nền nếp lớp học và làm gương tốt cho các bạn.",
          "{○○|Em} thể hiện tính tự giác cao và tôn trọng nội quy lớp học.",
          "{N} nắm rõ các quy định của lớp và luôn thực hiện nghiêm túc.",
          "Cách cư xử điềm tĩnh, hiểu chuyện của {N} là tấm gương cho các bạn.",
          "{○○|Em} luôn tự giác làm điều đúng đắn ngay cả khi không có người lớn giám sát.",
          "Nền nếp lớp học diễn ra suôn sẻ nhờ sự hợp tác và hỗ trợ của {N}."
        ]
      },
      "independent": {
        "kw": "tính tự lập",
        "lines": [
          "{N} tự giác thực hiện tốt các sinh hoạt hằng ngày ở lớp.",
          "{○○|Em} tự bảo quản đồ dùng cá nhân và hoàn thành nhiệm vụ mà không cần ai giúp.",
          "{N} tự giữ gìn đồ dùng cá nhân và chuẩn bị cho mỗi tiết học mà không cần nhắc nhở.",
          "Tính tự lập của {N} trong các sinh hoạt hằng ngày rất đáng khen.",
          "{○○|Em} tự tin giải quyết các công việc hằng ngày và chỉ nhờ giúp đỡ khi thật sự cần.",
          "{○○|Em} thu dọn đồ dùng và chuyển tiếp giữa các hoạt động rất nhanh nhẹn, gọn gàng."
        ]
      },
      "cleaning": {
        "kw": "sự chăm chỉ trực nhật",
        "lines": [
          "{N} thực hiện nhiệm vụ trực nhật nghiêm túc và dọn dẹp khu vực được phân công sạch bóng.",
          "{○○|Em} rất chăm chỉ trong giờ lao động vệ sinh.",
          "{N} làm việc tích cực trong giờ dọn vệ sinh và chú ý làm sạch từng góc nhỏ.",
          "Công việc trực nhật của {N} luôn được hoàn thành chu đáo mà không hề phàn nàn.",
          "{○○|Em} có ý thức giữ gìn lớp học của chúng ta luôn sạch đẹp, gọn gàng.",
          "Đến giờ dọn dẹp, luôn có thể yên tâm rằng {N} sẽ hoàn thành tốt công việc."
        ]
      },
      "cadre": {
        "kw": "sự tin cậy trong nhiệm vụ cán sự lớp",
        "lines": [
          "{N} thực hiện nhiệm vụ phụ giúp lớp một cách cẩn thận và đáng tin cậy.",
          "Trong vai trò cán sự lớp, {○○|em} luôn gương mẫu và hỗ trợ giáo viên rất tốt.",
          "{N} đảm nhận công việc của lớp với sự chững chạc và chu đáo.",
          "Sự tin cậy của {N} trong công việc chung là nguồn hỗ trợ lớn cho cả lớp.",
          "{○○|Em} tự giác hoàn thành nhiệm vụ được giao mà không cần nhắc nhở và là tấm gương tốt.",
          "Khi phụ trách công việc của lớp, {N} rất đáng tin cậy, ngăn nắp và công bằng."
        ]
      },
      "service": {
        "kw": "tinh thần vì tập thể",
        "lines": [
          "{N} sẵn lòng nhận các công việc chung của lớp và thực hiện nghiêm túc.",
          "{○○|Em} luôn sẵn sàng phụ giúp để hoạt động của lớp diễn ra suôn sẻ.",
          "{N} nhanh nhẹn xung phong mỗi khi lớp có việc cần làm.",
          "Sự nhiệt tình đóng góp cho tập thể của {N} được mọi người rất trân trọng.",
          "{○○|Em} chủ động nhận phần việc chung của lớp và hoàn thành cẩn thận.",
          "Mỗi khi cần người phụ giúp, {N} luôn là một trong những học sinh xung phong đầu tiên."
        ]
      },
      "sports": {
        "kw": "năng khiếu thể thao",
        "lines": [
          "{N} học tốt môn Thể dục và thể hiện tinh thần thể thao tuyệt vời.",
          "{○○|Em} mang đến nguồn năng lượng tích cực và tinh thần đồng đội cho các hoạt động thể thao.",
          "{N} vận động đầy năng lượng, khéo léo trong giờ Thể dục và luôn cổ vũ đồng đội.",
          "Sự phối hợp vận động và thể lực của {N} rất nổi bật trong các hoạt động thể chất.",
          "{○○|Em} chơi đẹp, tuân thủ luật chơi và giữ tinh thần thể thao tốt trong mọi trò chơi.",
          "Thể dục rõ ràng là thế mạnh của {N}, và {○○|em} luôn nỗ lực hết mình trong mọi hoạt động."
        ]
      },
      "art": {
        "kw": "năng khiếu nghệ thuật",
        "lines": [
          "{N} có năng khiếu thực sự về mỹ thuật, các sản phẩm đều sáng tạo và giàu màu sắc.",
          "Tranh vẽ và sản phẩm mỹ thuật của {N} thể hiện trí tưởng tượng phong phú cùng sự tỉ mỉ.",
          "{N} sử dụng màu sắc và chi tiết rất tinh tế trong các bài vẽ.",
          "Các sản phẩm mỹ thuật của {N} giàu tính sáng tạo và được hoàn thiện cẩn thận.",
          "{○○|Em} đến với nghệ thuật bằng trí tưởng tượng phong phú và sự sẵn sàng thử nghiệm.",
          "Sự sáng tạo luôn tỏa sáng trong từng tác phẩm nghệ thuật mà {○○|em} thực hiện."
        ]
      },
      "music": {
        "kw": "năng khiếu âm nhạc",
        "lines": [
          "{N} thể hiện năng khiếu âm nhạc rõ rệt và tham gia rất nhiệt tình.",
          "{○○|Em} có cảm thụ âm nhạc tốt và thích ca hát cũng như chơi nhạc cụ.",
          "{N} hát tự tin và giữ nhịp rất vững.",
          "Sự hào hứng với âm nhạc của {○○|em} tiếp thêm năng lượng cho các tiết học của lớp.",
          "{○○|Em} bắt nhịp và học các bài hát mới rất nhanh.",
          "Âm nhạc rõ ràng là niềm đam mê, và {N} luôn tham gia với niềm vui thực sự."
        ]
      },
      "writing": {
        "kw": "khả năng viết tốt",
        "lines": [
          "{N} viết mạch lạc và giàu trí tưởng tượng.",
          "Bài viết của {○○|em} có bố cục chặt chẽ và thể hiện vốn từ phong phú.",
          "{N} sử dụng từ ngữ thú vị và bố cục rõ ràng trong các bài viết.",
          "Những câu chuyện của {○○|em} giàu trí tưởng tượng và rất cuốn hút người đọc.",
          "{○○|Em} diễn đạt ý tưởng qua bài viết ngày càng khéo léo và chi tiết hơn.",
          "Viết lách là một thế mạnh thực sự, và {N} rất thích sáng tác truyện cũng như viết bài giải thích."
        ]
      },
      "creative": {
        "kw": "sự sáng tạo",
        "lines": [
          "{N} đóng góp nhiều ý tưởng sáng tạo cho các dự án và yêu thích các hoạt động thực hành.",
          "{○○|Em} có tư duy sáng tạo và tìm ra những hướng giải quyết mới mẻ cho vấn đề.",
          "{N} đưa ra nhiều ý tưởng độc đáo và thích lắp ráp, chế tạo đồ vật.",
          "Trí tưởng tượng của {○○|em} mang đến nhiều ý tưởng mới mẻ cho các dự án của lớp.",
          "{○○|Em} thích thử nghiệm và tìm ra những cách sáng tạo để giải quyết vấn đề.",
          "Các dự án thực hành làm nổi bật sự sáng tạo và tháo vát của {○○|em}."
        ]
      },
      "stage": {
        "kw": "kỹ năng nói rõ ràng",
        "lines": [
          "{N} trình bày rõ ràng và tự tin trước lớp.",
          "{○○|Em} là người thuyết trình truyền cảm và biết cách thu hút người nghe.",
          "{N} thuyết trình trước lớp với giọng nói rõ ràng và giao tiếp bằng mắt tốt.",
          "Các bài thuyết trình của {○○|em} được chuẩn bị kỹ lưỡng và rất lôi cuốn.",
          "{○○|Em} phát biểu tự tin trước đám đông và giải thích ý tưởng rõ ràng.",
          "Việc phát biểu trước mọi người đến với {○○|em} rất tự nhiên."
        ]
      },
      "logic": {
        "kw": "tư duy logic",
        "lines": [
          "{N} suy nghĩ logic và giải quyết vấn đề bằng nhiều cách khác nhau.",
          "{○○|Em} yêu thích những bài toán thử thách và lập luận rất rõ ràng.",
          "{N} chia nhỏ vấn đề theo từng bước và giải thích lập luận một cách mạch lạc.",
          "Tư duy logic của {○○|em} thể hiện rõ qua các câu đố và nhiệm vụ khó.",
          "{○○|Em} nhận ra quy luật rất nhanh và vận dụng chúng để tìm lời giải.",
          "Suy luận để giải các câu hỏi hóc búa là một trong những thế mạnh thực sự của {○○|em}."
        ]
      },
      "prog_study": {
        "kw": "sự tiến bộ rõ rệt trong học tập",
        "lines": [
          "{N} đã đạt được sự tiến bộ vượt bậc trong học tập ở học kỳ này.",
          "Sự chăm chỉ của {○○|em} đã được đền đáp bằng những tiến bộ vững vàng và rõ nét.",
          "Kết quả học tập của {○○|em} đã cải thiện đều đặn ở các môn học trong học kỳ này.",
          "{N} đã trưởng thành rõ rệt trong việc học suốt những tháng qua.",
          "Những tiến bộ mà {○○|em} đạt được trên lớp trong học kỳ này thể hiện rất rõ.",
          "{○○|Em} đã rèn luyện được kỹ năng vững vàng hơn và hiện có thể giải quyết tốt các bài tập khó hơn."
        ]
      },
      "prog_confidence": {
        "kw": "sự tự tin ngày càng lớn",
        "lines": [
          "{N} đã tự tin hơn và hiện sẵn sàng chia sẻ ý kiến hơn trước.",
          "Thật tuyệt vời khi thấy {○○|em} trở nên tự tin hơn trong học kỳ này.",
          "{N} hiện tham gia vào tiết học chủ động hơn nhiều so với đầu học kỳ.",
          "Sự tự tin ngày càng lớn của {○○|em} thể hiện qua cách {○○|em} thử sức với những điều mới.",
          "{○○|Em} đã sẵn sàng phát biểu và chia sẻ ý tưởng hơn.",
          "Sự tự tin mới mẻ thể hiện rõ trong bài làm và sự tham gia trên lớp của {○○|em}."
        ]
      },
      "prog_habit": {
        "kw": "thói quen hằng ngày tốt hơn",
        "lines": [
          "{N} đã có bước tiến lớn trong việc thực hiện nề nếp và tự giác điều chỉnh hành vi.",
          "Khả năng tập trung và thói quen học tập của {○○|em} đã cải thiện rõ rệt.",
          "{N} hiện thực hiện các nề nếp hằng ngày tự giác hơn rất nhiều.",
          "Sự ngăn nắp và tâm thế sẵn sàng cho tiết học của {○○|em} đã tiến bộ rất nhiều.",
          "{○○|Em} đã điềm tĩnh và tập trung hơn trong các tiết học.",
          "Những thói quen tốt hơn đã giúp {○○|em} học tập hiệu quả hơn mỗi ngày đến trường."
        ]
      },
      "prog_social": {
        "kw": "tình bạn gắn kết hơn",
        "lines": [
          "{N} đã trưởng thành hơn trong giao tiếp và hiện hòa đồng tốt với các bạn trong lớp.",
          "{○○|Em} đã học được cách bày tỏ cảm xúc bình tĩnh và hợp tác tốt với mọi người.",
          "{N} hiện làm việc thoải mái hơn với các bạn khi hoạt động theo cặp và theo nhóm.",
          "Sự thoải mái của {○○|em} khi làm việc với nhiều bạn khác nhau trong lớp đã tăng lên qua học kỳ này.",
          "{○○|Em} đã trở nên kiên nhẫn và thấu hiểu người khác hơn.",
          "Việc hòa đồng với các bạn trong lớp đã trở nên dễ dàng hơn nhiều đối với {○○|em} trong học kỳ này."
        ]
      },
      "a_concept": {
        "kw": "việc nắm vững {c}",
        "lines": [
          "Ở môn {subj}, {N} thể hiện sự hiểu biết vững chắc về {c}.",
          "{N} nắm bắt các kiến thức mới trong môn {subj} một cách nhanh chóng và chính xác.",
          "{N} hiểu rõ {c} và có thể giải thích được các ý chính.",
          "Sự hiểu biết của {○○|em} về {c} rất vững vàng và ngày càng sâu sắc.",
          "Khi có kiến thức mới trong môn {subj}, {N} biết liên hệ chúng với những gì {○○|em} đã biết.",
          "{○○|Em} nắm rõ các kiến thức trọng tâm trong môn {subj}."
        ]
      },
      "a_skill": {
        "kw": "sự tự tin trong {k}",
        "lines": [
          "{N} thể hiện kỹ năng ngày càng tiến bộ về {k}.",
          "Kỹ năng {k} của {○○|em} rất vững vàng và ổn định.",
          "{N} ngày càng tự tin hơn về {k}.",
          "Sự tiến bộ của {○○|em} về {k} thể hiện rõ trên lớp.",
          "{N} thực sự nỗ lực trong việc rèn luyện {k}.",
          "{N} xử lý các nhiệm vụ liên quan đến {k} ngày càng thuần thục."
        ]
      },
      "a_apply": {
        "kw": "việc vận dụng kiến thức",
        "lines": [
          "{N} vận dụng kiến thức môn {subj} vào các tình huống mới một cách dễ dàng.",
          "{N} tạo được sự liên hệ tốt giữa môn {subj} và cuộc sống hằng ngày.",
          "{N} sử dụng những gì {○○|em} đã học trong môn {subj} để giải quyết các nhiệm vụ mới.",
          "{○○|Em} có thể lấy ý tưởng từ môn {subj} và vận dụng theo những cách mới mẻ.",
          "{N} thường liên hệ những điều được học trong môn {subj} với thực tế cuộc sống.",
          "{N} áp dụng các kỹ năng mới từ môn {subj} một cách thiết thực."
        ]
      },
      "a_express": {
        "kw": "cách giải thích rõ ràng",
        "lines": [
          "{N} giải thích ý tưởng rõ ràng trong các buổi thảo luận môn {subj}.",
          "{N} tự tin chia sẻ ý kiến trong các tiết học môn {subj}.",
          "{N} truyền đạt ý tưởng trong môn {subj} một cách rõ ràng, cả khi nói lẫn khi viết.",
          "{○○|Em} chia sẻ suy nghĩ trong các tiết học môn {subj} và biết lắng nghe quan điểm của người khác.",
          "Những đóng góp của {○○|em} cho các buổi thảo luận môn {subj} rất sâu sắc và rõ ràng.",
          "Trong môn {subj}, {N} sử dụng vốn từ phù hợp để diễn đạt ý tưởng."
        ]
      },
      "a_explore": {
        "kw": "tinh thần ham học hỏi và tìm tòi",
        "lines": [
          "{N} đặt những câu hỏi sâu sắc và tích cực khám phá kiến thức trong môn {subj}.",
          "{N} thử nhiều cách tiếp cận khác nhau khi giải quyết vấn đề.",
          "{N} thích tìm hiểu các câu hỏi trong môn {subj} và đi tìm câu trả lời.",
          "Sự tò mò của {○○|em} trong môn {subj} dẫn đến nhiều câu hỏi rất sâu sắc.",
          "{○○|Em} sẵn sàng thử nghiệm ý tưởng và rút kinh nghiệm từ kết quả đạt được.",
          "Trong môn {subj}, {N} suy nghĩ cẩn thận và nhìn nhận vấn đề từ nhiều góc độ khác nhau."
        ]
      },
      "a_work": {
        "kw": "{w} cẩn thận",
        "lines": [
          "Phần {w} của {○○|em} được hoàn thành đầy đủ và cẩn thận.",
          "{N} luôn chú ý hoàn thành {w} một cách chu đáo.",
          "{N} hoàn thành {w} gọn gàng và đúng hạn.",
          "Phần {w} của {○○|em} thể hiện sự cẩn thận và chú ý đến từng chi tiết.",
          "{○○|Em} luôn tự hào khi thực hiện {w} một cách kỹ lưỡng và trình bày đẹp mắt.",
          "Phần {w} mà {○○|em} nộp luôn đầy đủ và được trình bày sạch đẹp."
        ]
      },
      "a_engage": {
        "kw": "sự tham gia nhiệt tình",
        "lines": [
          "{N} luôn tập trung và hào hứng trong các tiết học môn {subj}.",
          "{N} thể hiện sự yêu thích thực sự đối với môn {subj}.",
          "{N} hăng hái tham gia vào các hoạt động của môn {subj}.",
          "Sự nhiệt tình của {○○|em} đối với môn {subj} thể hiện rõ trong từng tiết học.",
          "{○○|Em} tham gia các tiết học môn {subj} với nhiều năng lượng và thái độ tích cực.",
          "{N} luôn mong chờ các tiết học môn {subj} và giữ được sự tập trung suốt buổi học."
        ]
      },
      "a_improve": {
        "kw": "sự tiến bộ vững chắc",
        "lines": [
          "{N} đã có sự tiến bộ đều đặn trong môn {subj} ở học kỳ này.",
          "Kết quả môn {subj} của {○○|em} tiếp tục được cải thiện.",
          "Kỹ năng môn {subj} của {○○|em} đã phát triển vững chắc trong học kỳ này.",
          "{N} đã đạt được những tiến bộ rõ rệt trong môn {subj} nhờ sự nỗ lực bền bỉ.",
          "Qua học kỳ vừa rồi, {○○|em} đã trở nên tự tin hơn trong môn {subj}.",
          "Mỗi tháng, {N} đều phát huy tốt những kiến thức đã học trước đó trong môn {subj}."
        ]
      }
    },
    "wishes": {
      "w_focus": [
        "Bước tiếp theo dành cho {○○|em} là duy trì sự tập trung trong giờ học, điều này sẽ giúp việc học trở nên hiệu quả và thú vị hơn nữa.",
        "Thầy/cô khuyến khích {○○|em} tập trung chú ý vào bài học và gác lại những yếu tố gây xao nhãng.",
        "Rèn luyện kỹ năng lắng nghe chủ động, chẳng hạn như hướng mắt về người đang nói, sẽ giúp {○○|em} nắm bắt trọn vẹn từng ý chính.",
        "Thầy/cô khuyến khích {○○|em} chỉ để trên bàn những đồ dùng cần thiết để dễ tập trung hơn.",
        "Tiếp tục rèn luyện sự tập trung khi tự làm bài sẽ giúp {○○|em} hoàn thành nhiệm vụ một cách tự tin."
      ],
      "w_careful": [
        "Dành một chút thời gian kiểm tra lại bài trước khi nộp sẽ giúp {○○|em} tránh được những lỗi nhỏ.",
        "Bước tiếp theo dành cho {○○|em} là làm bài chậm rãi hơn và kiểm tra lại câu trả lời.",
        "Đọc kỹ mỗi câu hỏi hai lần trước khi trả lời sẽ giúp {○○|em} phát hiện ra các lỗi nhỏ.",
        "Thầy/cô khuyến khích {○○|em} sử dụng một danh sách kiểm tra ngắn trước khi nộp bài.",
        "Dành thời gian xem lại câu trả lời sau mỗi bài tập sẽ giúp bài làm của {○○|em} chính xác hơn nữa."
      ],
      "w_homework": [
        "Xây dựng thói quen làm bài tập về nhà đều đặn sẽ giúp {○○|em} nộp bài đúng hạn.",
        "Thầy/cô khuyến khích {○○|em} kiểm tra danh sách bài tập về nhà mỗi ngày để không bỏ sót bài nào.",
        "Sử dụng bìa kẹp bài tập về nhà để mang bài giữa nhà và trường sẽ giúp mọi thứ luôn ngăn nắp, đúng tiến độ.",
        "Bước tiếp theo dành cho {○○|em} là bắt đầu làm bài tập về nhà vào cùng một khung giờ mỗi ngày.",
        "Cất bài tập đã làm xong vào cặp từ tối hôm trước sẽ giúp mang bài đến trường đúng hạn."
      ],
      "w_handwriting": [
        "Viết chậm rãi hơn sẽ giúp chữ viết của {○○|em} trở nên gọn gàng và dễ đọc hơn.",
        "Bước tiếp theo là chăm chút hơn cho chữ viết và cách trình bày bài.",
        "Luyện viết đúng nét chữ vài phút mỗi ngày sẽ giúp chữ viết của {○○|em} trông gọn gàng hơn.",
        "Thầy/cô khuyến khích {○○|em} chừa khoảng cách rõ ràng giữa các chữ và viết ngay ngắn trên dòng kẻ.",
        "Dành thêm một chút thời gian cho việc trình bày sẽ giúp những ý tưởng hay của {○○|em} tỏa sáng."
      ],
      "w_speak": [
        "Thầy/cô khuyến khích {○○|em} chia sẻ ý kiến thường xuyên hơn trên lớp, vì những suy nghĩ của {○○|em} rất đáng quý.",
        "Bước tiếp theo là giơ tay phát biểu thường xuyên hơn và tích cực tham gia thảo luận trên lớp.",
        "Trao đổi ý tưởng trước với một bạn cùng cặp sẽ giúp {○○|em} cảm thấy sẵn sàng chia sẻ trước cả lớp.",
        "Thầy/cô khuyến khích {○○|em} đặt mục tiêu nhỏ là đóng góp ý kiến ít nhất một lần trong mỗi buổi thảo luận.",
        "Chia sẻ suy nghĩ của {○○|em} thành lời thường xuyên hơn cũng sẽ giúp các bạn trong lớp học hỏi được từ {○○|em}."
      ],
      "w_emotion": [
        "Bước tiếp theo dành cho {○○|em} là hít một hơi thật sâu khi buồn bực rồi dùng lời nói để chia sẻ cảm xúc.",
        "Thực hành các cách giữ bình tĩnh sẽ giúp {○○|em} vượt qua cảm giác nản lòng hay bực bội.",
        "Nói rõ cảm xúc của mình thành lời sẽ giúp {○○|em} nhanh chóng nhận được sự hỗ trợ phù hợp.",
        "Thầy/cô khuyến khích {○○|em} nghỉ giải lao một lát và đếm đến năm khi cảm thấy mọi việc trở nên khó khăn.",
        "Bước tiếp theo là rèn luyện những cách bình tĩnh để đón nhận sự thất vọng, chẳng hạn như hít thở chậm rãi."
      ],
      "w_friends": [
        "Thầy/cô khuyến khích {○○|em} lắng nghe ý kiến của người khác và dùng lời lẽ tử tế khi có bất đồng.",
        "Tiếp tục rèn luyện sự kiên nhẫn với các bạn trong lớp sẽ giúp tình bạn ngày càng gắn bó.",
        "Thầy/cô khuyến khích {○○|em} rủ thêm nhiều bạn khác nhau cùng tham gia khi làm việc nhóm và khi vui chơi.",
        "Thực hành việc chờ đến lượt và biết sẻ chia sẽ giúp tình bạn của {○○|em} ngày càng bền chặt hơn.",
        "Bước tiếp theo dành cho {○○|em} là bình tĩnh trao đổi khi có bất đồng và cùng tìm giải pháp công bằng."
      ],
      "w_tidy": [
        "Dành một phút mỗi ngày để dọn gọn bàn học và cặp sách của {○○|em} sẽ giúp các tiết học diễn ra suôn sẻ hơn.",
        "Bước tiếp theo là giữ đồ dùng học tập ngăn nắp và luôn sẵn sàng cho giờ học.",
        "Sử dụng một danh sách kiểm tra đơn giản vào cuối ngày sẽ giúp {○○|em} giữ đồ dùng học tập gọn gàng.",
        "Thầy/cô khuyến khích {○○|em} cất từng món đồ về đúng chỗ ngay sau khi sử dụng.",
        "Bước tiếp theo là sắp xếp các bìa hồ sơ theo phân loại để dễ dàng tìm thấy giấy tờ, tài liệu."
      ],
      "w_reading": [
        "Đọc sách 10 phút mỗi ngày sẽ giúp {○○|em} tích lũy vốn từ vựng và kỹ năng đọc hiểu.",
        "Thầy/cô khuyến khích {○○|em} khám phá thêm nhiều cuốn sách ở nhà.",
        "Đọc to vài phút hầu hết các ngày trong tuần sẽ giúp rèn luyện sự lưu loát và tự tin.",
        "Thầy/cô khuyến khích {○○|em} thử đọc sách thuộc các thể loại mới, chẳng hạn như sách phi hư cấu hoặc thơ ca.",
        "Trò chuyện về từng cuốn sách sau khi đọc xong sẽ giúp {○○|em} hiểu sâu hơn."
      ],
      "w_initiative": [
        "Bước tiếp theo dành cho {○○|em} là chủ động nhờ giúp đỡ ngay khi có điều gì chưa rõ.",
        "Chủ động hơn trong học tập sẽ giúp {○○|em} vươn tới nấc thang mới.",
        "Thầy/cô khuyến khích {○○|em} đặt câu hỏi bất cứ khi nào thấy tò mò.",
        "Chủ động bước đầu tự bắt tay vào làm bài sẽ giúp {○○|em} trưởng thành hơn trong học tập.",
        "Bước tiếp theo là tìm thêm thử thách mới sau khi hoàn thành bài trên lớp."
      ],
      "w_rules": [
        "Thầy/cô khuyến khích {○○|em} tiếp tục duy trì nền nếp lớp học, chẳng hạn như biết đợi đến lượt và kiên nhẫn chờ đợi.",
        "Bước tiếp theo là ghi nhớ các quy ước của lớp trong suốt cả ngày.",
        "Tiếp tục thực hiện tốt quy ước của lớp trong lúc chuyển tiết sẽ giúp một ngày học diễn ra suôn sẻ.",
        "Thầy/cô khuyến khích {○○|em} dừng lại một nhịp và suy nghĩ xem lựa chọn của mình ảnh hưởng đến người khác như thế nào.",
        "Rèn luyện thói quen chờ đến lượt mới phát biểu sẽ giúp {○○|em} thể hiện sự tôn trọng với các bạn trong lớp."
      ],
      "w_confidence": [
        "Thầy/cô khuyến khích {○○|em} mạnh dạn thử sức với những thử thách mới, vì mắc lỗi cũng là một phần của việc học.",
        "Bước tiếp theo là tin tưởng vào {khả năng của bản thân ○○|chính mình} thêm một chút nữa.",
        "Thử sức với một thử thách mới mỗi tuần sẽ giúp {○○|em} xây dựng sự tự tin.",
        "Thầy/cô khuyến khích {○○|em} trân trọng những thành công nhỏ và nhớ rằng sự nỗ lực mới là điều quan trọng nhất.",
        "Bước tiếp theo là thỉnh thoảng thử chọn phần bài khó hơn, với sự an tâm rằng thầy/cô luôn sẵn sàng hỗ trợ."
      ],
      "w_time": [
        "Sử dụng sổ kế hoạch đơn giản để sắp xếp bài tập về nhà và việc ôn tập sẽ giúp {○○|em} bớt cảm thấy vội vàng.",
        "Bước tiếp theo là rèn luyện kỹ năng lập kế hoạch thời gian và sắp xếp thứ tự ưu tiên cho công việc.",
        "Chia nhỏ các nhiệm vụ lớn thành từng bước nhỏ sẽ giúp {○○|em} theo kịp tiến độ.",
        "Thầy/cô khuyến khích {○○|em} bắt đầu làm sớm các bài tập dài thay vì để đến phút chót.",
        "Sử dụng đồng hồ bấm giờ trong lúc làm bài sẽ giúp {○○|em} tập trung theo đúng tiến độ."
      ]
    },
    "areas": {
      "chinese": {
        "subj": "Ngữ văn",
        "c": "đọc hiểu và từ vựng",
        "k": "đọc và viết",
        "w": "bài viết"
      },
      "math": {
        "subj": "Toán học",
        "c": "khái niệm số học và hình học",
        "k": "tính toán và giải quyết vấn đề",
        "w": "bài luyện tập"
      },
      "english": {
        "subj": "Tiếng Anh",
        "c": "từ vựng và mẫu câu",
        "k": "nghe và nói",
        "w": "bài tập về nhà môn Tiếng Anh"
      },
      "social": {
        "subj": "Khoa học xã hội",
        "c": "chủ đề cộng đồng và lịch sử",
        "k": "tìm hiểu và thuyết trình",
        "w": "bài dự án"
      },
      "science": {
        "subj": "Khoa học",
        "c": "khái niệm khoa học trọng tâm",
        "k": "quan sát và thí nghiệm",
        "w": "bài thực hành thí nghiệm"
      },
      "arts": {
        "subj": "Nghệ thuật",
        "c": "ý tưởng mỹ thuật và âm nhạc cơ bản",
        "k": "sáng tạo và biểu diễn",
        "w": "tác phẩm nghệ thuật"
      },
      "pe": {
        "subj": "Giáo dục thể chất và Sức khỏe",
        "c": "lối sống lành mạnh",
        "k": "kỹ năng vận động",
        "w": "bài học thể chất và sức khỏe"
      },
      "integrative": {
        "subj": "Kỹ năng sống",
        "c": "tự nhận thức và kỹ năng sống",
        "k": "hoạt động nhóm",
        "w": "bài thực hành hoạt động"
      },
      "life": {
        "subj": "Tự nhiên và Xã hội",
        "c": "thế giới quanh ta",
        "k": "quan sát và thực hành làm sản phẩm",
        "w": "bài dự án"
      }
    },
    "frames": {
      "openings": [
        {
          "t": "Thật vui khi có ○○ trong lớp ở học kỳ này.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ đã có một học kỳ thật tuyệt vời.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "Một học kỳ thật tuyệt vời đối với ○○!",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "Thật vui khi có em trong lớp của chúng ta ở học kỳ này.",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○ ơi, em đã có một học kỳ thật tuyệt vời!",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○ đã có một học kỳ thành công.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "formal"
        },
        {
          "t": "{○○|Em} đã thể hiện sự tiến bộ vững vàng trong học kỳ này.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○|Em} đã cho thấy sự trưởng thành rõ rệt trong học kỳ này.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "Thời gian gần đây {○○|em} học tập và rèn luyện trên lớp rất tốt.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "Thầy/cô muốn chia sẻ một vài tin vui về ○○.",
          "u": [
            "brief",
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ ơi, hôm nay em làm tốt lắm!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○ ơi, hôm nay thầy/cô nhận thấy một điều rất tuyệt vời ở em!",
          "u": [
            "cheer"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "{○○|Em} đã có bước tiến bộ vượt bậc trong học kỳ này.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Học kỳ này đã mang lại sự thay đổi thật tích cực cho {○○|em}!",
          "u": [
            "special"
          ],
          "f": "progress",
          "tone": "warm"
        },
        {
          "t": "Mỗi học sinh đều có nhịp độ học tập riêng, và ○○ đang tiến bộ vững vàng.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "parent"
        },
        {
          "t": "Mỗi người đều có nhịp độ học tập riêng, và em đang tiến bộ vững vàng.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "child"
        },
        {
          "t": "{○○|Em} đã có một học kỳ bận rộn và hiệu quả.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Học kỳ này là khoảng thời gian {○○|em} thực sự trưởng thành.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Được dạy {○○|em} trong học kỳ này là một niềm vui lớn.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Thầy/cô rất vui khi được đồng hành và hiểu thêm về {○○|em} trong học kỳ này.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "{○○|Em} đã giải quyết các bài học trong học kỳ này với sự tự lập ngày càng cao.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "Báo cáo này tổng kết sự tiến bộ và những điểm mạnh của {N} trong học kỳ này.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Đây là vài dòng cập nhật nhanh về tình hình học tập của {○○|em}.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "{○○|Em} đã có vài tuần học tập rất tốt trên lớp.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "Mọi việc trên lớp của {○○|em} đều đang diễn ra thuận lợi.",
          "u": [
            "brief"
          ],
          "tone": "warm"
        },
        {
          "t": "Thầy/cô có đôi lời khen ngợi muốn chia sẻ về ○○.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "Đây là đôi dòng nhắn gửi để biểu dương ○○.",
          "u": [
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ rất xứng đáng nhận được lời khen ngợi.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "○○ ơi, đây là lời nhắn dành riêng cho em.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○ ơi, em hoàn toàn có thể tự hào về bản thân mình.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Làm tốt lắm, ○○!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Sự tiến bộ của {N} trong học kỳ này thể hiện rất rõ ràng.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Đây là một học kỳ có nhiều tiến bộ thực chất đối với {○○|em}.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○|Em} đã có những bước tiến quan trọng trong học kỳ này.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○|Em} đang tiến bộ với nhịp độ vừa sức, từng bước một.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Việc học cần có thời gian, và {○○|em} đang từng bước tích lũy kỹ năng một cách vững chắc.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Thầy/cô rất vui được chia sẻ những điều {○○|em} đã làm tốt trong học kỳ này.",
          "u": [
            "special"
          ],
          "f": "support",
          "tone": "warm"
        }
      ],
      "fillers": [
        {
          "t": "Thật đáng quý khi được chứng kiến {○○|em} trưởng thành qua những tháng vừa qua.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Những phẩm chất này giúp {○○|em} trở thành một thành viên đáng quý của lớp chúng ta.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Cảm ơn gia đình đã luôn đồng hành và hỗ trợ ở nhà.",
          "u": [
            "term",
            "brief",
            "special"
          ],
          "p": "parent"
        },
        {
          "t": "Nhìn chung, sự thể hiện của {○○|em} trong học kỳ này rất ổn định.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Sự tiến bộ này là kết quả của quá trình nỗ lực đều đặn hằng ngày.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Nếu tiếp tục rèn luyện, thầy/cô tin chắc rằng {○○|em} sẽ gặt hái được kết quả tốt.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Thầy/cô sẽ tiếp tục hỗ trợ {○○|em} ở trường.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "{○○|Em} đã học tập và rèn luyện rất đều đặn trong học kỳ này.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Nhìn chung, sự tiến bộ ở mảng này là rất tốt.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "{N} tham gia tích cực vào các tiết học {subj} và hoàn thành tốt nhiệm vụ trên lớp.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{N} đang từng bước xây dựng kỹ năng vững vàng trong môn {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Sự nỗ lực của em luôn được thầy/cô ghi nhận.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "child"
        },
        {
          "t": "{○○|Em} đã hòa nhập tốt với nền nếp của lớp và bắt đầu mỗi ngày học với thái độ tích cực.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○|Em} đã đóng góp rất nhiều cho tập thể lớp của chúng ta trong học kỳ này.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Thật vui khi được nhìn thấy những điểm mạnh của {N} phát triển qua học kỳ vừa rồi.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Trong suốt học kỳ, {○○|em} đã đáp ứng tốt các yêu cầu bằng sự nỗ lực bền bỉ và tích cực.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○|Em} tiếp tục trưởng thành hơn trong học tập cũng như trong vai trò là một thành viên của lớp.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○|Em} đón nhận mỗi ngày đến trường với tinh thần sẵn sàng học hỏi.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○|Em} đã trở thành một thành viên vững vàng và đáng tin cậy trong lớp của chúng ta.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Sự nỗ lực mà {○○|em} bỏ ra mỗi ngày đều thể hiện rất rõ ràng.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○|Em} đã xây dựng được mối quan hệ tốt đẹp với cả bạn bè trong lớp và thầy cô.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Có thể thấy rõ rằng {○○|em} rất quan tâm đến việc học tập và rèn luyện tốt ở trường.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○|Em} ngày càng tự lập hơn qua từng chặng của học kỳ.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Tinh thần tích cực của {N} giúp cả lớp cùng học tập tốt.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Thầy/cô rất vui khi thấy sự tự tin của {N} lớn dần lên qua từng tuần.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Thái độ học tập của {N} luôn duy trì sự ổn định và tích cực.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Những bước tiến nhỏ nhưng đều đặn đang góp lại thành sự tiến bộ thực sự cho {○○|em}.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Mỗi tuần đều mang đến những cơ hội mới để rèn luyện, và {○○|em} đang tận dụng rất tốt những cơ hội đó.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Sự tiến bộ trong học kỳ này cho thấy nỗ lực bền bỉ có thể mang lại kết quả như thế nào.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{N} thực hiện tốt hướng dẫn trong môn {subj} và làm bài cẩn thận.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{N} đang hình thành những thói quen học tập tốt trong môn {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Kết quả làm bài của {N} trong môn {subj} ở học kỳ này phản ánh sự nỗ lực đều đặn.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Nhìn chung, sự nỗ lực thể hiện trong môn {subj} rất ổn định.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "Mỗi bước tiến nhỏ của em đều thực sự có ý nghĩa.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Sự chăm chỉ của em đang tạo nên thay đổi tích cực rõ rệt.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Sự nỗ lực của ○○ luôn được thầy/cô ghi nhận.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "parent"
        }
      ],
      "closings": [
        {
          "t": "{Mong rằng ○○ sẽ tiếp tục phát huy những điểm mạnh này!|Hãy tiếp tục phát huy nhé!}",
          "u": [
            "term",
            "brief",
            "cheer",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "{Tôi hy vọng ○○ sẽ tiếp tục phát huy những kết quả tốt này.|Hãy tiếp tục phát huy nhé.}",
          "u": [
            "term",
            "brief",
            "subject",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Thầy/cô rất mong được thấy {○○|em} tiếp tục tỏa sáng trong học kỳ tới.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Thầy/cô tin chắc rằng {○○|em} sẽ có một học kỳ tiếp theo còn vững vàng hơn nữa.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Thầy/cô chúc {○○|em} gặt hái thật nhiều thành công trong chặng đường tiếp theo.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "{Mong rằng ○○ sẽ tiếp tục duy trì phong độ tốt này!|Cứ thế phát huy nhé!}",
          "u": [
            "brief",
            "cheer",
            "subject"
          ]
        },
        {
          "t": "Thầy/cô tự hào về em!",
          "u": [
            "cheer",
            "special"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "Hãy tiếp tục tỏa sáng nhé!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Chúng ta sẽ cùng nhau tiếp tục nỗ lực hướng tới những mục tiêu này.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "{○○|Em} đã hoàn thành rất tốt học kỳ này.",
          "u": [
            "subject",
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Thầy/cô rất mong chờ tất cả những điều mà {○○|em} sẽ đạt được trong học kỳ tới.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Chúc cho học kỳ sắp tới của {○○|em} sẽ lại là một học kỳ thật tuyệt vời nữa!",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Chúc {○○|em} có một kỳ nghỉ ngơi thật thoải mái và một khởi đầu tràn đầy năng lượng cho học kỳ tới.",
          "u": [
            "term"
          ]
        },
        {
          "t": "{○○|Em} hoàn toàn có thể tự hào về những thành quả đạt được trong học kỳ này.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Được dạy ○○ trong học kỳ này là một niềm vinh hạnh của thầy/cô.",
          "u": [
            "term"
          ],
          "p": "parent"
        },
        {
          "t": "Cảm ơn em vì tất cả sự chăm chỉ và nỗ lực trong học kỳ này.",
          "u": [
            "term"
          ],
          "p": "child"
        },
        {
          "t": "Thầy/cô sẽ tiếp tục cập nhật tình hình tiến bộ của ○○ tới gia đình.",
          "u": [
            "brief"
          ],
          "p": "parent"
        },
        {
          "t": "{Những kết quả tích cực của ○○ đang dần hé mở khi con tiếp tục cố gắng!|Những điều tuyệt vời đang dần hé mở, hãy tiếp tục cố gắng nhé!}",
          "u": [
            "brief",
            "cheer"
          ],
          "tone": "warm"
        },
        {
          "t": "Sự nỗ lực bền bỉ như thế này sẽ đưa {○○|em} tiến xa.",
          "u": [
            "brief",
            "cheer",
            "special"
          ]
        },
        {
          "t": "{○○|Em} đang đi đúng hướng.",
          "u": [
            "brief",
            "subject",
            "special"
          ]
        },
        {
          "t": "Thầy/cô rất mong được thấy {○○ có thêm nhiều tiến bộ hơn nữa|em tiến bộ hơn nữa} ở môn {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Việc tiếp tục rèn luyện sẽ giúp {○○|em} phát huy hơn nữa những điểm mạnh này.",
          "u": [
            "subject",
            "special"
          ]
        },
        {
          "t": "{○○ đã thể hiện rất tốt và rất đáng khích lệ.|Làm tốt lắm, hãy tiếp tục cố gắng nhé.}",
          "u": [
            "cheer",
            "brief"
          ]
        },
        {
          "t": "Em làm được mà!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Mỗi bước tiến về phía trước đều đáng quý, và phía trước vẫn còn rất nhiều bước tiến mới đang chờ đón {○○|em}.",
          "u": [
            "special"
          ],
          "f": "support"
        }
      ]
    },
    "elaborations": {
      "area": [
        "Điều này cho thấy một nền tảng vững chắc ở môn {subj}.",
        "Sự tiến bộ của {N} ở môn {subj} rất đáng khích lệ.",
        "Nhìn chung, kết quả học tập ở môn {subj} rất vững vàng.",
        "Chất lượng bài làm của {N} ở môn {subj} cho thấy sự cẩn thận và tâm huyết thực sự.",
        "Đây là nền tảng vững chắc cho giai đoạn học tập tiếp theo ở môn {subj}.",
        "{○○|Em} đã có sự chuẩn bị tốt cho những bước tiếp theo ở môn {subj}.",
        "Thật đáng mừng khi thấy sự tiến bộ này trong môn {subj}."
      ],
      "learning": [
        "Phương pháp học tập này đã mang lại cho {○○|em} một nền tảng vững chắc ở các môn học.",
        "Những thói quen này sẽ giúp ích rất nhiều cho {○○|em} trong những năm tới.",
        "Nhờ vậy, kết quả học tập của {N} luôn duy trì ở mức tốt.",
        "{○○|Em} đang hình thành những thói quen tốt dẫn đến thành công lâu dài.",
        "Sự bền bỉ này được thể hiện rõ qua chất lượng bài làm hằng ngày của {N}.",
        "Thái độ tích cực như vậy khiến việc dạy dỗ {○○|em} trở thành một niềm vui.",
        "Những điểm mạnh này giúp {○○|em} tiếp thu trọn vẹn từng bài học."
      ],
      "character": [
        "Những phẩm chất này còn đáng quý hơn cả điểm số.",
        "{○○|Em} nhận được sự yêu mến và tôn trọng từ cả thầy cô lẫn bạn bè.",
        "Thật vui khi được chứng kiến những phẩm chất tốt đẹp như vậy mỗi ngày.",
        "Các bạn trong lớp đều biết rằng mình có thể tin cậy ở {○○|em}.",
        "{○○|Em} luôn âm thầm làm gương qua những việc làm tuy nhỏ nhưng đầy ý nghĩa.",
        "Phẩm chất tốt đẹp này góp phần xây dựng một tập thể lớp biết yêu thương và quan tâm lẫn nhau.",
        "Những phẩm chất như thế này sẽ là hành trang quý giá cho {○○|em} cả khi bước ra ngoài trường học."
      ],
      "social": [
        "Các bạn trong lớp rất thích cùng học và cùng chơi với {○○|em}.",
        "{○○|Em} góp phần làm cho lớp học của chúng ta trở thành một nơi ấm áp và thân thiện.",
        "Những kỹ năng giao tiếp này thực sự là một điểm sáng đáng quý.",
        "Các hoạt động nhóm diễn ra suôn sẻ hơn khi có {○○|em} cùng tham gia.",
        "Những kỹ năng này giúp mọi thành viên trong lớp đều cảm thấy được gắn kết.",
        "Biết hợp tác tốt với mọi người là một trong những kỹ năng quý giá nhất.",
        "{○○|Em} luôn truyền cảm hứng tích cực cho những người xung quanh."
      ],
      "routine": [
        "Những thói quen tốt này giúp việc học tập trở nên hiệu quả hơn.",
        "{○○|Em} là tấm gương sáng cho các bạn noi theo.",
        "Quản lý tốt các công việc hằng ngày là một bước trưởng thành quan trọng.",
        "Sự chuẩn bị chu đáo và ngăn nắp giúp tiết kiệm nhiều thời gian hơn cho việc học.",
        "Những nề nếp này giúp {○○|em} bắt đầu mỗi ngày mới một cách bình tĩnh và vững vàng.",
        "Những thói quen tốt như vậy sẽ rèn luyện tính tự lập thực sự.",
        "{○○|Em} cho thấy những thói quen nhỏ hằng ngày có thể tạo nên sự khác biệt lớn."
      ],
      "service": [
        "Tinh thần sẵn sàng cống hiến này giúp lớp học của chúng ta ngày càng tốt đẹp hơn.",
        "Nhờ có sự giúp đỡ của {N}, các hoạt động thường ngày của lớp diễn ra trôi chảy hơn.",
        "Dành thời gian giúp đỡ người khác là một điều rất đáng tự hào.",
        "Việc nhiệt tình giúp đỡ như vậy thể hiện sự chững chạc thực sự.",
        "{○○|Em} luôn vui vẻ hoàn thành các nhiệm vụ được giao, điều đó rất đáng trân trọng.",
        "Tập thể lớp chúng ta gắn kết và vững mạnh hơn nhờ những sự giúp đỡ như thế này.",
        "Tinh thần vì tập thể này là một phẩm chất rất đáng trân quý."
      ],
      "talent": [
        "Hy vọng {○○|em} sẽ tiếp tục phát huy năng khiếu này.",
        "Năng khiếu này đóng góp rất nhiều cho các hoạt động của lớp chúng ta.",
        "Thật hào hứng khi được chứng kiến năng khiếu này ngày càng phát triển.",
        "Thật tuyệt vời khi thấy {○○|em} chia sẻ năng khiếu này với cả lớp.",
        "{○○|Em} hoàn toàn có quyền tự hào về năng khiếu này của mình.",
        "Nếu tiếp tục rèn luyện, năng khiếu này chắc chắn sẽ còn tiến xa hơn nữa.",
        "Điểm mạnh này mang đến cho {○○|em} cơ hội tỏa sáng theo cách rất riêng."
      ],
      "progress": [
        "Sự tiến bộ này không dễ dàng đạt được và rất xứng đáng được ghi nhận.",
        "Có thể thấy rõ {○○|em} đã nỗ lực rất nhiều.",
        "Thầy/cô thực sự rất vui mừng khi thấy sự thay đổi này.",
        "Sự tiến bộ này là minh chứng cho những gì mà nỗ lực bền bỉ có thể đạt được.",
        "{○○|Em} đã tiến một bước rất dài, và điều đó thật đáng chúc mừng.",
        "Từng bước tiến nhỏ đã góp lại thành một sự thay đổi thực sự.",
        "Sự tiến bộ này là nền tảng tuyệt vời cho những tháng sắp tới."
      ]
    },
    "compact": [
      {
        "t": "{○○|Em} đã thể hiện nhiều điểm mạnh, bao gồm {L}."
      },
      {
        "t": "Những điểm nổi bật bao gồm {L}."
      },
      {
        "t": "Điểm mạnh của {N} bao gồm {L}."
      },
      {
        "t": "{○○|Em} nổi bật với {L}."
      },
      {
        "t": "Trong số những điểm mạnh của {N} phải kể đến {L}."
      },
      {
        "t": "Những điểm mạnh chính trong học kỳ này là {L}.",
        "tone": "formal"
      },
      {
        "t": "Thật vui khi thấy {L} trong suốt học kỳ qua.",
        "tone": "warm",
        "u": [
          "term",
          "brief",
          "special"
        ]
      },
      {
        "t": "Tôi rất vui được ghi nhận {L}.",
        "tone": "formal"
      }
    ],
    "connectors": [
      "Thêm vào đó, ",
      "Ngoài ra, ",
      "Bên cạnh đó, "
    ],
    "wishLeads": [
      "",
      "",
      "Trong thời gian tới, "
    ],
    "you": "em",
    "possessive": "của em",
    "blankName": "[Tên]",
    "and": "và",
    "unit": "từ"
  },
  "roster": {
    "sheet": "Danh sách lớp",
    "guideSheet": "Hướng dẫn",
    "seat": "Mã số học sinh",
    "name": "Tên học sinh",
    "group": "Nhóm",
    "gender": "Giới tính",
    "avatar": "Loại ảnh đại diện",
    "instructions": [
      "Chỉ điền vào trang Danh sách lớp, mỗi học sinh một dòng.",
      "Giữ nguyên tiêu đề ở dòng đầu tiên. Chỉ bắt buộc điền Tên học sinh.",
      "Mã số học sinh là không bắt buộc. Định dạng các giá trị như 01 và 02 thành văn bản (Text) để giữ số 0 ở đầu.",
      "Tên có thể dài tối đa 30 ký tự và không được trùng nhau trong cùng một lớp. Nhập tối đa 100 học sinh mỗi lần.",
      "Việc nhập danh sách học sinh trong lần thiết lập đầu tiên là không bắt buộc. Bạn có thể thêm sau tại trang Học sinh.",
      "Sử dụng tệp .xlsx, .xls, .ods hoặc CSV chuẩn UTF-8. Tệp CSV chỉ lưu một trang tính và văn bản thuần túy.",
      "Không đưa vào công thức, macro, số điện thoại, địa chỉ email hoặc dữ liệu cá nhân không cần thiết khác của học sinh.",
      "Trang danh sách lớp đang để trống. Trang hướng dẫn này sẽ không được nhập vào hệ thống."
    ],
    "male": "nam",
    "female": "nữ"
  },
  "demo": {
    "teacher": "Cô Minh Anh",
    "workspace": "Lớp học mẫu ClassMori",
    "className": "Lớp 3A",
    "individualClassName": "Lớp 3B",
    "cycle": "Chu kỳ 1",
    "pet": "Bé Mầm",
    "individualPet": "Bạn nhỏ đồng hành",
    "groups": [
      "Tổ Họa Mi",
      "Tổ Sơn Ca",
      "Tổ Vành Khuyên",
      "Tổ Hải Âu"
    ],
    "names": [
      "An Nhiên",
      "Bảo Nam",
      "Châu Anh",
      "Đức Minh",
      "Gia Hân",
      "Hải Đăng",
      "Khánh Linh",
      "Lâm Phong",
      "Minh Khôi",
      "Ngọc Diệp",
      "Phúc Lâm",
      "Quỳnh Chi",
      "Thanh Tùng",
      "Thảo Nguyên",
      "Tuấn Kiệt",
      "Uyên Nhi",
      "Việt Hoàng",
      "Xuân Mai",
      "Yến Trang",
      "Hoàng Bách",
      "Phương Anh",
      "Quốc Bảo",
      "Thiên Ân",
      "Trúc Linh"
    ],
    "surpriseItems": [
      [
        "Viên nang rừng xanh",
        "🎁",
        6,
        "capsule",
        [
          [
            "Chọn một sticker",
            "🌈",
            "common"
          ],
          [
            "Trợ lý của thầy cô",
            "🤝",
            "common"
          ],
          [
            "Tự chọn chỗ ngồi 1 ngày",
            "🪑",
            "uncommon"
          ],
          [
            "Phiếu miễn bài tập",
            "📝",
            "rare"
          ]
        ]
      ],
      [
        "Thẻ cào may mắn",
        "🍀",
        6,
        "scratch",
        [
          [
            "Chọn nhạc giờ ăn trưa",
            "🎵",
            "common"
          ],
          [
            "Ngồi cạnh bạn thân 1 ngày",
            "👫",
            "uncommon"
          ],
          [
            "Làm lớp trưởng 1 ngày",
            "👑",
            "rare"
          ]
        ]
      ]
    ],
    "routines": [
      "Đọc sách",
      "Thảo luận",
      "Dọn dẹp"
    ]
  },
  "schema": {
    "home": "Trang chủ",
    "freeTool": "công cụ miễn phí",
    "product": {
      "description": "Điểm thưởng lớp học và thú cưng lớp học dành cho giáo viên: chọn học sinh, chạm vào lý do khen thưởng, và thú cưng sẽ lớn lên theo từng điểm cộng. Không cần tài khoản học sinh; miễn phí trọn đời cho 1 lớp học.",
      "free": "Gói miễn phí",
      "yearly": "Gói Plus, theo năm",
      "monthly": "Gói Plus, theo tháng",
      "plus": "Gói Pro, theo năm",
      "plusMonthly": "Gói Pro, theo tháng"
    },
    "socialAlt": "ClassMori: giáo viên và học sinh trong lớp học rừng xanh cùng thú cưng của lớp"
  },
  "corePages": {
    "/": {
      "title": "ClassMori | Điểm thưởng lớp học giúp nuôi lớn thú cưng cho mỗi học sinh",
      "description": "Ứng dụng điểm thưởng và nuôi thú cưng lớp học dành cho giáo viên: chọn học sinh, chạm vào lý do và ngắm nhìn thú cưng lớn lên theo từng điểm số. Mỗi học sinh một thú cưng hoặc cả lớp nuôi chung một thú cưng. Dùng ngay trên máy chiếu hoặc điện thoại, không cần tài khoản học sinh. Miễn phí cho 1 lớp tối đa 40 học sinh."
    },
    "/about": {
      "title": "Về chúng tôi | ClassMori",
      "description": "Khám phá ClassMori: phản hồi tích cực, cụ thể và những người bạn đồng hành rừng xanh giúp giáo viên ghi nhận sự tiến bộ của từng học sinh."
    },
    "/pricing": {
      "title": "Bảng giá | ClassMori",
      "description": "ClassMori miễn phí trọn đời cho 1 lớp tối đa 40 học sinh. Gói Plus có giá 3 USD/tháng hoặc 19 USD/năm (9,90 USD cho năm đầu tiên) cho 5 lớp, mỗi lớp tối đa 100 học sinh. Ngoài ra còn có gói Pro và báo giá dành cho trường học."
    },
    "/tour": {
      "title": "Dùng thử bảng điều khiển giáo viên | ClassMori",
      "description": "Không cần đăng ký: trải nghiệm ngay chế độ thú cưng chung cả lớp và thú cưng riêng cho từng học sinh. Chọn học sinh, cộng điểm và xem thú cưng thay đổi. Các thay đổi chỉ lưu trên trang này và sẽ đặt lại khi tải lại trang; tất cả học sinh đều là giả định."
    },
    "/privacy": {
      "title": "Chính sách quyền riêng tư | ClassMori",
      "description": "Cách ClassMori xử lý tài khoản giáo viên và dữ liệu lớp học, cũng như cách yêu cầu dữ liệu của bạn."
    },
    "/terms": {
      "title": "Điều khoản dịch vụ | ClassMori",
      "description": "Điều khoản dịch vụ, phạm vi dịch vụ và quy định tài khoản của ClassMori."
    },
    "/contact": {
      "title": "Liên hệ | ClassMori",
      "description": "Bạn có câu hỏi, góp ý hay muốn mua gói cho trường học? Hãy liên hệ với đội ngũ ClassMori."
    }
  },
  "scene": {
    "pets": {
      "otter": {
        "name": "Mori",
        "species": "rái cá",
        "foodName": "tôm"
      },
      "rabbit": {
        "name": "Bông Xù",
        "species": "thỏ",
        "foodName": "cà rốt"
      },
      "penguin": {
        "name": "Bánh Bao",
        "species": "chim cánh cụt",
        "foodName": "cá"
      }
    },
    "lines": {
      "calm": [
        "Mình ở ngay đây. Cứ thong thả nhé.",
        "Những bước tiến nhỏ cũng thật đáng khen!",
        "Sẵn sàng chưa? Cùng tiến lên nào!",
        "Từng bước một sẽ giúp chúng mình đi xa hơn.",
        "Hít một hơi thật sâu. Một nhiệm vụ nhỏ mới đang chờ.",
        "Hôm nay có bao nhiêu điều mới để khám phá!",
        "Tặng bạn một chút dũng khí nhé.",
        "Ý tưởng của bạn rất đáng để chia sẻ đấy!",
        "Cùng nhau tạo nên một ngày thật ấm áp nhé.",
        "Mình rất thích được học cùng bạn!"
      ],
      "react": [
        "Ôi, cảm ơn bạn vì đã dịu dàng như thế!",
        "Cảm ơn bạn, cảm giác thật ấm áp.",
        "Hì hì, thật vui vì chúng mình là bạn tốt!",
        "Một cái chạm nhẹ, ngập tràn yêu thương.",
        "Tặng bạn một trái tim thật to này!",
        "Có bạn ở đây, hôm nay lại càng đáng yêu hơn.",
        "Hãy lan tỏa tâm trạng vui vẻ tới mọi người nhé!",
        "Bạn ấm áp như một tia nắng nhỏ vậy.",
        "Những cử chỉ tử tế nhỏ bé mang lại niềm vui lớn!",
        "Trái tim nhỏ của mình đang vẫy chào bạn đấy!"
      ],
      "wave": [
        "Chào bạn! Hôm nay cùng cố gắng hết mình nhé!",
        "Nhìn thấy bạn là mình vui lắm!",
        "Vẫy tay chào! Tâm trạng vui vẻ tới rồi đây!",
        "Xin chào! Bạn đã sẵn sàng cùng học chưa?",
        "Hãy gửi một nụ cười cho người bạn bên cạnh nhé!",
        "Lời chào của bạn vừa thắp sáng cả khu rừng nhỏ.",
        "Hãy quay sang chào người bạn ở gần mình nhé!",
        "Lễ phép mang lại cảm giác thật ấm áp.",
        "Một cái vẫy tay, thêm một chút tự tin!",
        "Các bạn đều đông đủ rồi. Xuất phát thôi!"
      ],
      "eat": [
        "Cảm ơn bạn vì món {food}! Mình sẽ ăn từ từ.",
        "Bạn chăm sóc các bạn thật chu đáo.",
        "Ăn nhẹ một chút rồi mình lại tiếp tục nhé!",
        "Măm măm! Tâm trạng vui vẻ vào thẳng trong bụng rồi!",
        "Bạn chăm sóc mình khéo quá.",
        "Sẻ chia giúp niềm vui nhân đôi!",
        "Món {food} này đong đầy sự tử tế.",
        "Chiếc bụng no tròn đã sẵn sàng cho thử thách mới!",
        "Cảm ơn bạn vì đã nhớ chăm sóc mình.",
        "No căng rồi! Tặng bạn một nụ cười tươi này!"
      ],
      "drink": [
        "Ực ực, cảm ơn bạn đã quan tâm chăm sóc mình!",
        "Uống một ngụm nước là tràn đầy năng lượng ngay!",
        "Bạn cũng nhớ uống nước nữa nhé!",
        "Những giọt nước nhỏ mang lại tâm trạng thật tươi vui.",
        "Biết tự chăm sóc bản thân là điều rất tuyệt vời!",
        "Nghỉ ngơi một lát rồi tiếp tục cố gắng nhé.",
        "Cảm ơn bạn, ngụm nước này làm ấm cả lòng mình!",
        "Chúng mình vừa cùng nhau nghỉ uống nước xong!",
        "Khi cơ thể khỏe khoắn, mình học tập cũng tốt hơn.",
        "Tỉnh táo và sẵn sàng cho những khám phá mới!"
      ],
      "stretch": [
        "Vươn vai một cái, năng lượng quay trở lại rồi!",
        "Giơ tay lên cao, đón niềm vui dạt dào!",
        "Xoay nhẹ đôi vai và tự cổ vũ bản thân nào.",
        "Nghỉ ngơi một chút sẽ giúp chúng mình đi xa hơn.",
        "Hít thở sâu nào. Cùng thư giãn nhé.",
        "Từ đầu đến chân, tất cả đã sẵn sàng!",
        "Bạn đã chăm chỉ rồi. Nhớ giữ gìn sức khỏe nữa nhé.",
        "Vươn vai thư giãn, nở nụ cười tươi!",
        "Nghỉ ngơi đôi chút sẽ giúp bước tiếp theo vững vàng hơn.",
        "Đỡ hơn nhiều rồi! Cùng thử lại lần nữa nhé!"
      ],
      "celebrate": [
        "Làm tốt lắm! Tặng bạn một ngôi sao nỗ lực này!",
        "Mình thấy bạn đã làm rất cẩn thận đấy!",
        "Hoàn thành tốt nhiệm vụ xứng đáng một tràng pháo tay!",
        "Bạn đã dũng cảm thử sức. Thật tuyệt vời!",
        "Hôm nay lại tiến bộ thêm một chút. Hoan hô!",
        "Bạn làm việc đó tỉ mỉ quá. Cừ lắm!",
        "Cổ vũ bạn thật nhiều. Hãy tiếp tục tỏa sáng nhé!",
        "Mọi nỗ lực nhỏ bé đều xứng đáng được ghi nhận!",
        "Bạn làm tốt quá, mình vui đến mức nhảy cẫng lên này!",
        "Tuyệt quá! Cùng vỗ tay khen ngợi sự tiến bộ của bạn nào!"
      ],
      "sleep": [
        "Nghỉ ngơi một chút để nạp lại năng lượng.",
        "À… Mình đang ở ngay bên bạn trong khu rừng nhỏ.",
        "Một khoảnh khắc yên tĩnh làm lòng mình thật dịu êm.",
        "Gói ghém những tiến bộ hôm nay vào giấc mơ ngọt ngào.",
        "Sau khi chăm chỉ học tập, hãy nghỉ ngơi thật tốt nhé!",
        "Vầng trăng nhỏ mang theo những giấc mơ êm đềm tới rồi.",
        "Khép đôi mắt lại và giữ một nụ cười cho riêng mình nhé.",
        "Nghỉ ngơi đủ rồi. Mình lại tiếp tục lên đường thôi.",
        "Cảm ơn bạn vì hôm nay đã cố gắng thật nhiều!",
        "Trong giấc mơ ngọt ngào của mình cũng có nụ cười của bạn đấy."
      ],
      "jump": [
        "Một, hai, ba, nhảy lên vì sung sướng!",
        "Nhảy một bước nhỏ để gửi niềm vui đến bạn!",
        "Đôi chân nhỏ của mình ngập tràn niềm vui.",
        "Bật nhảy lên cao, lòng dũng cảm cũng lớn thêm một chút!",
        "Cùng vẫy tay chào đón niềm vui nào!",
        "Tiếp đất thật êm, cười thật tươi!",
        "Một bước nhảy vui tươi. Cùng tiến lên nào!",
        "Thêm nhiều tiếng cười rộn vang trong khu rừng nhỏ!",
        "Hãy chia sẻ tâm trạng vui vẻ của ngày hôm nay nhé!",
        "Chơi cùng bạn thật là vui!"
      ],
      "wake": [
        "Mình dậy rồi! Cảm ơn bạn đã đánh thức mình thật nhẹ nhàng.",
        "Một nhiệm vụ nhỏ mới. Cùng nhau thực hiện nhé!",
        "Mắt sáng long lanh, tâm trạng tươi xanh!",
        "Đã nghỉ ngơi khỏe khoắn. Mình lại tràn đầy năng lượng rồi.",
        "Cảm ơn bạn đã kiên nhẫn chờ đợi nhé!",
        "Vươn vai một chút và gửi tặng bạn một nụ cười.",
        "Sẵn sàng rồi! Cùng bước tiếp về phía trước nào!",
        "Ngủ thật ngon giấc, tràn đầy dũng khí!",
        "Thức dậy thấy bạn ở đây thật là hạnh phúc.",
        "Khu rừng nhỏ đã thức giấc. Lên đường thôi!"
      ],
      "read": [
        "Mình đang đọc một cuốn sách nhỏ rất thú vị.",
        "Trang này kể về những người bạn trong rừng.",
        "Chờ chút, mình muốn xem lại trang này lần nữa.",
        "Cùng nhau lắng nghe câu chuyện này nhé."
      ],
      "homework": [
        "Mình đang làm bài tập. Sắp xong rồi!",
        "Viết chậm rãi mà cẩn thận thì vẫn rất đáng khen.",
        "Để mình suy nghĩ kỹ hơn về câu này một chút.",
        "Xong rồi! Chúng mình đều đang tiến bộ từng ngày."
      ],
      "paint": [
        "Mình đang vẽ một bông hoa nhỏ.",
        "Vẽ cánh hoa trước, rồi đến lá cây.",
        "Màu sắc yêu thích của bạn là gì?",
        "Hoàn thành rồi! Tặng bạn bức tranh này nhé."
      ],
      "rope": [
        "Mình đang nhảy dây. Cùng giữ nhịp nhé!",
        "Một, hai, bật nhảy thật nhẹ nhàng.",
        "Sợi dây vừa lướt qua ngay dưới chân mình!",
        "Nhảy thêm một cái nữa. Vui quá đi thôi!"
      ]
    }
  },
  "sceneUi": {
    "ClassMori · Forest pet scene": "ClassMori · Khung cảnh thú cưng rừng xanh",
    "The forest pet's little forest": "Khu rừng nhỏ của thú cưng rừng xanh",
    "Forest pet interactive scene": "Khung cảnh tương tác cùng thú cưng rừng xanh",
    "Your browser needs Canvas support to show the forest pet.": "Trình duyệt của bạn cần hỗ trợ Canvas để hiển thị thú cưng rừng xanh.",
    "Hi! Let's do our best today!": "Chào bạn! Hôm nay cùng cố gắng hết mình nhé!",
    "A gentle pat. Your friend in the egg heard you!": "Vỗ nhẹ thật êm. Người bạn nhỏ trong trứng đã nghe thấy bạn rồi!",
    "Knock, knock. We're waiting for you out here!": "Cốc, cốc. Chúng mình đang chờ bạn ở ngoài này!",
    "Oh? A tiny sound from inside the egg!": "Ồ? Có tiếng động nhỏ phát ra từ bên trong quả trứng!",
    "Something is moving in the den. Let's wait quietly.": "Có gì đó đang cử động trong ổ. Hãy yên lặng chờ xem nhé.",
    "Pat the egg": "Xoa nhẹ quả trứng",
    "Knock gently": "Gõ nhẹ nhàng",
    "Little wing": "Đôi cánh nhỏ",
    "Pat to respond": "Chạm nhẹ để tương tác",
    " · Drag to pick up": " · Kéo để bế lên",
    ". Tap to get a reaction; drag to gently pick up.": ". Chạm để xem phản ứng; kéo để nhẹ nhàng bế lên."
  },
  "languageSuggestion": {
    "region": "Ngôn ngữ",
    "available": "Trang này đã có phiên bản tiếng Việt",
    "view": "Xem trang này bằng tiếng Việt",
    "dismiss": "Đóng"
  },
  "heroAlt": "Chế độ máy chiếu ClassMori với danh sách học sinh giả định và thú cưng đang lớn lên của các em.",
  "sceneArrival": {
    "otter": {
      "waiting": "Sột soạt, sột soạt… có gì đó đang nhúc nhích trong hốc cây.",
      "peek": "{name} đang ló đầu ra kìa! Đã sẵn sàng chào cả lớp rồi.",
      "hello": "Xin chào! Cảm ơn mọi người đã kiên nhẫn chờ đợi nhé."
    },
    "rabbit": {
      "waiting": "Tấm rèm lá khẽ đung đưa. {name} đang nghỉ ngơi bên trong.",
      "peek": "Đôi tai dài đang nhô ra kìa! {name} muốn gửi lời chào.",
      "hello": "Chào mọi người! Hãy cùng nhau cố gắng và lớn khôn nhé!"
    },
    "penguin": {
      "waiting": "Quả trứng khẽ lúc lắc. Người bạn mới của bạn đang chuẩn bị chào đời.",
      "peek": "Vỏ trứng mở ra rồi! {name} đang ngó nghiêng ngắm nhìn thế giới.",
      "hello": "Chíp chíp! Cảm ơn đã cổ vũ cho mình. Mình tới đây!"
    }
  },
  "sceneRegions": {
    "ear": "Tai phải",
    "earleft": "Tai trái",
    "footleft": "Chân trái",
    "footright": "Chân phải",
    "tail": "Đuôi",
    "handleft": "Bàn tay nhỏ",
    "wave": "Bàn tay nhỏ",
    "wingleft": "Cánh trái",
    "wingright": "Cánh phải",
    "tuft": "Chỏm lông đầu",
    "face": "Má",
    "body": "Bụng",
    "sleep": "Đánh thức nhẹ nhàng"
  },
  "commentLanguageFaq": {
    "question": "Tôi có thể tạo nhận xét bằng ngôn ngữ khác không?",
    "answer": "Có. Các cài đặt mới sẽ mặc định theo ngôn ngữ của trang này. Hãy dùng mục Ngôn ngữ để chọn tiếng Trung, tiếng Anh, tiếng Tây Ban Nha, tiếng Pháp, tiếng Bồ Đào Nha (Brazil), tiếng Thổ Nhĩ Kỳ, tiếng Việt hoặc tiếng Indonesia. Nhận xét sẽ sử dụng kho mẫu câu bằng ngôn ngữ đã chọn; tên học sinh được điền trực tiếp trên thiết bị."
  },
  "reasonAliases": {
    "Nộp bài đúng hạn": "homework",
    "Hợp tác": "teamwork",
    "Tập trung trong giờ học": "focus",
    "Hoàn thành thử thách": "persist",
    "Giúp đỡ bạn bè": "helpful",
    "Giơ tay phát biểu": "speak",
    "Hăng hái giơ tay": "speak"
  }
}
